export const API = {
  tripGroupings: {
    getAll: {
      url: '/trip-groupings',
      method: 'GET'
    },
    create: {
      url: '/trip-groupings',
      method: 'POST'
    },
    update: {
      url: '/trip-groupings/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/trip-groupings/:id',
      method: 'DELETE'
    },
    get: {
      url: '/trip-groupings/:id',
      method: 'GET'
    },
    exportExcel: {
      url: '/trip-groupings/export-excel',
      method: 'POST'
    },
    assignTrips: {
      url: '/trip-groupings/:id/assign-trips',
      method: 'POST'
    },
    unassignTrips: {
      url: '/trip-groupings/:id/unassign-trips',
      method: 'DELETE'
    },
    getTripGroupingsByTrips: {
      url: '/trip-groupings/by-trips',
      method: 'GET'
    }
  },
  cse: {
    create: {
      url: '/cse',
      method: 'POST'
    },
    getAll: {
      url: '/cse',
      method: 'GET'
    },
    get: {
      url: '/cse/:id',
      method: 'GET'
    },
    getByCode: {
      url: '/cse/code/:cseCode',
      method: 'GET'
    },
    update: {
      url: '/cse/:id',
      method: 'PATCH'
    },
    generateCodePartner: {
      url: '/cse/code-partner',
      method: 'GET'
    },
    delete: {
      url: '/cse/:id',
      method: 'DELETE'
    },
    createReductionRule: {
      url: '/cse/:id/reduction-rules',
      method: 'POST'
    },
    getAllReductionRules: {
      url: '/cse/:id/reduction-rules',
      method: 'GET'
    },
    getReductionRule: {
      url: '/cse/:id/reduction-rules/:ruleId',
      method: 'GET'
    },
    updateReductionRule: {
      url: '/cse/:id/reduction-rules/:ruleId',
      method: 'PATCH'
    },
    deleteReductionRule: {
      url: '/cse/:id/reduction-rules/:ruleId',
      method: 'DELETE'
    },
    createContact: {
      url: '/cse/:id/cse-contacts',
      method: 'POST'
    },
    getAllContacts: {
      url: '/cse/:id/cse-contacts',
      method: 'GET'
    },
    getContact: {
      url: '/cse/:id/cse-contacts/:contactId',
      method: 'GET'
    },
    updateContact: {
      url: '/cse/:id/cse-contacts/:contactId',
      method: 'PATCH'
    },
    deleteContact: {
      url: '/cse/:id/cse-contacts/:contactId',
      method: 'DELETE'
    },
    sendCodeToPartners: {
      url: '/cse/send-code-to-partners',
      method: 'POST'
    },
    closeCatalog: {
      url: '/cse/:id/close-catalog',
      method: 'POST'
    },
    openCatalog: {
      url: '/cse/:id/open-catalog',
      method: 'POST'
    },
    sendEmail: {
      url: '/cse/send-email',
      method: 'POST'
    }
  },
  auth: {
    login: {
      url: '/auth/login',
      method: 'POST'
    },
    'sso-login': {
      url: '/auth/sso-login',
      method: 'POST'
    },
    'authenticate-token': {
      url: '/auth/authenticate-token',
      method: 'POST'
    },
    impersonate: {
      url: '/auth/impersonate/:id',
      method: 'POST'
    },
    forgotPassword: {
      url: '/auth/forgot-password',
      method: 'POST'
    },
    resetPassword: {
      url: '/auth/reset-password',
      method: 'POST'
    },
    reconnect: {
      url: '/auth/reconnect',
      method: 'POST'
    },
    isUserImpersonated: {
      url: '/auth/is-user-impersonated',
      method: 'GET'
    },
    logout: {
      url: '/auth/logout',
      method: 'POST'
    },
    terminateSession: {
      url: '/auth/terminate-session',
      method: 'POST'
    }
  },
  user: {
    getMe: {
      url: '/auth/me',
      method: 'GET'
    },
    getAll: {
      url: '/users',
      method: 'GET'
    },
    create: {
      url: '/users',
      method: 'POST'
    },
    update: {
      url: '/users/:id',
      method: 'PATCH'
    },
    activate: {
      url: '/users/:id/activate',
      method: 'POST'
    },
    deactivate: {
      url: '/users/:id/deactivate',
      method: 'POST'
    },
    block: {
      url: '/users/:id/block',
      method: 'POST'
    }
  },
  journeyPlaces: {
    getAll: {
      url: '/journey-places',
      method: 'GET'
    },
    get: {
      url: '/journey-places/:id',
      method: 'GET'
    },
    exportExcel: {
      url: '/journey-places/export-excel',
      method: 'POSt'
    },
    create: {
      url: '/journey-places',
      method: 'POST'
    },
    update: {
      url: '/journey-places/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/journey-places/:id',
      method: 'DELETE'
    },
    getOtoIndividualPlaces: {
      url: '/journey-places/:id/oto-individual-places',
      method: 'GET'
    },
    getAllOtoIndividualPlaces: {
      url: '/journey-places/oto-individual-places',
      method: 'GET'
    },
    createOtoIndividualPlace: {
      url: '/journey-places/:id/oto-individual-places',
      method: 'POST'
    },
    updateOtoIndividualPlace: {
      url: '/journey-places/:id/oto-individual-places/:otoIndividualPlaceId',
      method: 'PATCH'
    },
    deleteOtoIndividualPlace: {
      url: '/journey-places/:id/oto-individual-places/:otoIndividualPlaceId',
      method: 'DELETE'
    }
  },
  insurances: {
    getAll: {
      url: '/insurances',
      method: 'GET'
    },
    suggestions: {
      url: '/insurances/suggestions',
      method: 'GET'
    },
    get: {
      url: '/insurances/:id',
      method: 'GET'
    },
    create: {
      url: '/insurances',
      method: 'POST'
    },
    update: {
      url: '/insurances/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/insurances',
      method: 'DELETE'
    }
  },
  candidate: {
    getAll: {
      url: '/staff-applications',
      method: 'GET'
    },
    get: {
      url: '/staff-applications/:id',
      method: 'GET'
    },
    update: {
      url: '/staff-applications/:id',
      method: 'PATCH'
    },
    assignToPcr: {
      url: '/staff-applications/assign-to-pcr',
      method: 'POST'
    },
    validate: {
      url: '/staff-applications/validate',
      method: 'POST'
    },
    reject: {
      url: '/staff-applications/reject',
      method: 'POST'
    },
    createStaffApplication: {
      url: '/staff-applications',
      method: 'POST'
    },
    checkSsnDataValidity: {
      url: '/staff-applications/check-ssn-data-validity',
      method: 'POST'
    },
    checkSsnFormatValidity: {
      url: '/staff-applications/check-ssn-format-validity',
      method: 'POST'
    },
    sendReminderToPcr: {
      url: '/staff-applications/send-reminder-to-pcr',
      method: 'POST'
    },
    sendEmailToStaff: {
      url: '/staff-applications/send-email-to-staffs',
      method: 'POST'
    },
    markAsPaid: {
      url: '/staff-applications/mark-as-paid',
      method: 'POST'
    },
    changeApplicationPriority: {
      url: '/staff-applications/:id/priority',
      method: 'PATCH'
    },
    changeApplicationStatus: {
      url: '/staff-applications/:id/status',
      method: 'PATCH'
    },
    changeApplicationEvaluation: {
      url: '/staff-applications/:id/evaluation',
      method: 'PATCH'
    },
    getStaffApplicationCurrentScoreCard: {
      url: '/staff-applications/:id/current-score-card',
      method: 'GET'
    }
  },
  products: {
    getAll: {
      url: '/products',
      method: 'GET'
    },
    get: {
      url: '/products/:id',
      method: 'GET'
    },
    getActions: {
      url: '/products/:id/actions',
      method: 'GET'
    },
    create: {
      url: '/products',
      method: 'POST'
    },
    update: {
      url: '/products/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/products/:id',
      method: 'DELETE'
    },
    exportExcel: {
      url: '/products/export-excel',
      method: 'POST'
    },
    getAllProductDates: {
      url: '/product-dates',
      method: 'GET'
    },
    getDatesDuration: {
      url: '/product-dates/duration',
      method: 'GET'
    },
    createProductDate: {
      url: '/product-dates',
      method: 'POST'
    },
    updateProductDate: {
      url: '/product-dates/:id',
      method: 'POST'
    },
    getProductOptions: {
      url: '/product-dates/:id/options',
      method: 'GET'
    },
    deleteProductDate: {
      url: '/product-dates/:id',
      method: 'DELETE'
    },
    lockProductDate: {
      url: '/product-dates/:id/lock',
      method: 'POST'
    },
    unlockProductDate: {
      url: '/product-dates/:id/unlock',
      method: 'POST'
    },
    duplicateProductDate: {
      url: '/product-dates/:id/duplicate',
      method: 'POST'
    },
    updateProductDatesBasePrice: {
      url: '/product-dates/base-price',
      method: 'PATCH'
    },
    getOtoIndividualProducts: {
      url: '/products/oto-individual',
      method: 'GET'
    },
    getAllJourneys: {
      url: '/journeys',
      method: 'GET'
    },
    exportJourneysExcel: {
      url: '/journeys/export-excel',
      method: 'POST'
    },
    createJourney: {
      url: '/journeys',
      method: 'POST'
    },
    updateJourney: {
      url: '/journeys/:id',
      method: 'PATCH'
    },
    deleteJourney: {
      url: '/journeys/:id',
      method: 'DELETE'
    },
    getJourney: {
      url: '/journeys/:id',
      method: 'GET'
    },
    duplicateJourney: {
      url: '/journeys/:id/duplicate',
      method: 'POST'
    },
    createTripOptions: {
      url: '/journeys/:id/trip-options',
      method: 'POST'
    },
    publishTripOptionGroup: {
      url: '/journeys/:id/trip-options-group/publish',
      method: 'POST'
    },
    unpublishTripOptionGroup: {
      url: '/journeys/:id/trip-options-group/unpublish',
      method: 'POST'
    },
    publishTripOption: {
      url: '/journeys/:id/trip-options/:tripId/publish',
      method: 'POST'
    },
    unpublishTripOption: {
      url: '/journeys/:id/trip-options/:tripId/unpublish',
      method: 'POST'
    },
    deleteTripOptionsGroup: {
      url: '/journeys/:id/trip-options-group',
      method: 'DELETE'
    },
    publishJourney: {
      url: '/journeys/publish',
      method: 'POST'
    },
    unpublishJourney: {
      url: '/journeys/unpublish',
      method: 'POST'
    },
    getJourneyTripOptions: {
      url: '/journeys/:id/trip-options',
      method: 'GET'
    },
    getSecondaryTripsByTripPlace: {
      url: '/journeys/:id/secondary-trips',
      method: 'GET'
    },
    getMainTripsByTripPlaceAndSecondaryTrip: {
      url: '/journeys/:id/main-trips',
      method: 'GET'
    },
    getPlacesByTripPlaceAndSecondaryTripAndMainTrip: {
      url: '/journeys/:id/places',
      method: 'GET'
    },
    createProductTuitionDaysNumber: {
      url: '/products/:productId/tuition-days-numbers',
      method: 'POST'
    },
    updateProductTuitionDaysNumber: {
      url: '/products/:productId/tuition-days-numbers/:tuitionDaysNumberId',
      method: 'PATCH'
    },
    deleteProductTuitionDaysNumber: {
      url: '/products/:productId/tuition-days-numbers/:tuitionDaysNumberId',
      method: 'DELETE'
    },
    getProductTuitionDaysNumbers: {
      url: '/products/:productId/tuition-days-numbers',
      method: 'GET'
    },
    getProductJourneyPlaces: {
      url: '/products/:productId/journey-places',
      method: 'GET'
    },
    createProductJourneyPlace: {
      url: '/products/:productId/journey-places',
      method: 'POST'
    },
    deleteProductJourneyPlaces: {
      url: '/products/:productId/journey-places',
      method: 'DELETE'
    }
  },
  staffCoordinates: {
    getAll: {
      url: '/staff-coordinates',
      method: 'GET'
    },
    exportExcel: {
      url: '/staff-coordinates/export-excel',
      method: 'POST'
    }
  },
  staffs: {
    getAll: {
      url: '/staffs',
      method: 'GET'
    },
    getAllDocuments: {
      url: '/staffs-documents',
      method: 'GET'
    },
    validate: {
      url: '/staffs-documents/:id/validate',
      method: 'POST'
    },
    invalidate: {
      url: '/staffs-documents/:id/invalidate',
      method: 'POST'
    },
    printCompletePdf: {
      url: '/staffs/print-complete-pdf',
      method: 'POST'
    },
    printPartialPdf: {
      url: '/staffs/print-partial-pdf',
      method: 'POST'
    },
    create: {
      url: '/staffs',
      method: 'POST'
    },
    get: {
      url: '/staffs/:id',
      method: 'GET'
    },
    connect: {
      url: '/staffs/:id/connect',
      method: 'POST'
    },
    checkIfStaffIsCurrentlyInJourney: {
      url: '/staffs/:id/is-currently-in-journey',
      method: 'GET'
    },
    getStaffTotalJourneys: {
      url: '/staffs/:id/total-journeys',
      method: 'GET'
    },

    adminUpdate: {
      url: '/staffs/admin/:id',
      method: 'PATCH'
    },
    deactivate: {
      url: '/staffs/:id/deactivate',
      method: 'POST'
    },
    reactivate: {
      url: '/staffs/:id/reactivate',
      method: 'POST'
    },
    exportExcel: {
      url: '/staffs/export-excel',
      method: 'POST'
    },

    getStaffMissingDocuments: {
      url: '/staffs-documents/:id/missing-documents',
      method: 'GET'
    },
    getStaffProfileProgress: {
      url: '/staffs/:id/profile-progress',
      method: 'GET'
    },
    update: {
      url: '/staffs',
      method: 'PATCH'
    },
    getAvailabilies: {
      url: '/staffs-availabilities/:id',
      method: 'GET'
    },
    getAffectations: {
      url: '/staffs/:id/affectations',
      method: 'GET'
    },
    getIdDocumentRules: {
      url: '/staffs/:id/identity-document-rules',
      method: 'GET'
    },
    addAvailability: {
      url: '/staffs-availabilities/:id',
      method: 'POST'
    },
    updateAvailability: {
      url: '/staffs-availabilities/:id/:availabilityId',
      method: 'PATCH'
    },
    deleteAvailability: {
      url: '/staffs-availabilities/:id/:availabilityId',
      method: 'DELETE'
    },
    getStaffContracts: {
      url: '/staffs/:id/contracts',
      method: 'GET'
    },
    getStaffMissions: {
      url: '/staffs/:id/missions',
      method: 'GET'
    },
    payScale: {
      url: '/staffs/:id/staff-request/:staffRequestId/salary',
      method: 'GET'
    }
  },
  tripDates: {
    getAll: {
      url: '/trip-dates',
      method: 'GET'
    },
    get: {
      url: '/trip-dates/:id',
      method: 'GET'
    },
    updateAllocatedPlaces: {
      url: '/trip-dates/:id/allocated-places',
      method: 'PATCH'
    },
    dispatch: {
      url: '/trip-dates/:id/dispatch',
      method: 'POST'
    },
    getTripManagers: {
      url: '/trip-dates/:id/trip-managers',
      method: 'GET'
    },
    retain: {
      url: '/trip-dates/:id/retain',
      method: 'POST'
    },
    getTripPlaceToCenterRequests: {
      url: '/trip-dates/:id/trip-place-to-center-requests',
      method: 'GET'
    },
    getRecommendedAllocations: {
      url: '/trip-dates/:id/recommended-allocations',
      method: 'GET'
    },
    getAllocatedPlaces: {
      url: '/trip-dates/:id/allocated-places',
      method: 'GET'
    }
  },
  allocatedPlaces: {
    getAll: {
      url: '/allocated-places',
      method: 'GET'
    }
  },
  rads: {
    getAll: {
      url: '/rads',
      method: 'GET'
    },
    create: {
      url: '/rads',
      method: 'POST'
    },
    delete: {
      url: '/rads',
      method: 'DELETE'
    },
    sendEmailToStaffs: {
      url: '/rads/send-email-to-staffs',
      method: 'POST'
    },
    sendRadStaffReminder: {
      url: '/rads/:id/send-reminder-to-staffs',
      method: 'POST'
    },
    get: {
      url: '/rads/:id',
      method: 'GET'
    },
    update: {
      url: '/rads/:id',
      method: 'PATCH'
    },
    printRadPli: {
      url: '/rads/:id/print-pli',
      method: 'GET'
    },
    printNameCards: {
      url: '/rads/:id/print-name-cards',
      method: 'POST'
    },
    printAttendanceSheet: {
      url: '/rads/:id/print-attendance-sheet',
      method: 'POST'
    },
    printAttendanceSheetByCenters: {
      url: '/rads/:id/print-attendance-sheet-by-centers',
      method: 'POST'
    },
    printAttendanceSheetAlphabetically: {
      url: '/rads/:id/print-attendance-sheet-alphabetically',
      method: 'POST'
    },
    printAttendanceSheetRandomly: {
      url: '/rads/:id/print-attendance-sheet-randomly',
      method: 'POST'
    },
    assignJourneys: {
      url: '/rads/:id/assign-journeys',
      method: 'PATCH'
    },
    unassignJourney: {
      url: '/rads/:id/unassign-journey/:journeyId',
      method: 'DELETE'
    },
    getAffectedStaffs: {
      url: '/rads/:id/affected-staffs',
      method: 'GET'
    },
    getParticipants: {
      url: '/rads/:id/participants',
      method: 'GET'
    },
    updateRadParticipant: {
      url: '/rads/:id/participants/:participantId',
      method: 'PATCH'
    },
    printRadCenterPli: {
      url: '/rads/:id/centers/:centerId/print-pli',
      method: 'POST'
    },
    printParticipantPli: {
      url: '/rads/:id/participants/:participantId/print-pli',
      method: 'POST'
    },
    getRadPliTemplates: {
      url: '/rads/:id/pli-templates',
      method: 'GET'
    },
    getRadCenters: {
      url: '/rads/:id/centers',
      method: 'GET'
    },
    getRadParticipants: {
      url: '/rads/:id/participants',
      method: 'GET'
    }
  },
  hostComments: {
    create: {
      url: '/host-comments',
      method: 'POST'
    },
    update: {
      url: '/host-comments/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/host-comments/:id',
      method: 'DELETE'
    }
  },
  hostFamilies: {
    getAll: {
      url: '/host-families',
      method: 'GET'
    },
    create: {
      url: '/host-families',
      method: 'POST'
    },
    delete: {
      url: '/host-families',
      method: 'DELETE'
    },
    get: {
      url: '/host-families/:id',
      method: 'GET'
    },
    getHostFamilyComments: {
      url: '/host-families/:id/comments',
      method: 'GET'
    },
    getStudentAppreciations: {
      url: '/host-families/:id/students-appreciations',
      method: 'GET'
    },
    update: {
      url: '/host-families/:id',
      method: 'PATCH'
    },
    exportHostFamiliesExcel: {
      url: '/host-families/export-excel',
      method: 'POST'
    },
    sendEmailToHostFamilies: {
      url: '/host-families/send-email',
      method: 'POST'
    },
    activate: {
      url: '/host-families/activate',
      method: 'PATCH'
    },
    deactivate: {
      url: '/host-families/deactivate',
      method: 'PATCH'
    },
    createHostFamilyLecComment: {
      url: '/host-families/:hostFamilyId/lec-comments',
      method: 'POST'
    },
    getHostFamilyLecComments: {
      url: '/host-families/:hostFamilyId/lec-comments',
      method: 'GET'
    },
    getHostFamilyLecCommentGuests: {
      url: '/host-families/:hostFamilyId/lec-comments/guests',
      method: 'GET'
    },
    updateHostFamilyLecComment: {
      url: '/host-families/:hostFamilyId/lec-comments/:id',
      method: 'PATCH'
    },
    deleteHostFamilyLecComments: {
      url: '/host-families/:hostFamilyId/lec-comments',
      method: 'DELETE'
    },
    createHostFamilyOlComment: {
      url: '/host-families/:hostFamilyId/ol-comments',
      method: 'POST'
    },
    getHostFamilyOlComments: {
      url: '/host-families/:hostFamilyId/ol-comments',
      method: 'GET'
    },
    updateHostFamilyOlComment: {
      url: '/host-families/:hostFamilyId/ol-comments/:id',
      method: 'PATCH'
    },
    deleteHostFamilyOlComments: {
      url: '/host-families/:hostFamilyId/ol-comments',
      method: 'DELETE'
    }
  },
  pcr: {
    getAll: {
      url: '/pcrs',
      method: 'GET'
    },
    get: {
      url: '/pcrs/:id',
      method: 'GET'
    },
    create: {
      url: '/pcrs',
      method: 'POST'
    },
    update: {
      url: '/pcrs/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/pcrs/:id',
      method: 'DELETE'
    },
    payments: {
      url: '/pcrs/:id/payments',
      method: 'GET'
    },
    getStaffApplications: {
      url: '/pcrs/:id/staff-applications',
      method: 'GET'
    },
    getStaffApplicationsStatistics: {
      url: '/pcrs/:id/staff-applications-statistics',
      method: 'GET'
    },
    resetPassword: {
      url: '/pcrs/reset-password',
      method: 'POST'
    }
  },
  places: {
    getPlaces: {
      url: '/places',
      method: 'GET'
    },
    getPlaceDetails: {
      url: '/places/:placeId',
      method: 'GET'
    }
  },
  paymentConditions: {
    getAll: {
      url: '/payment-conditions',
      method: 'GET'
    },
    get: {
      url: '/payment-conditions/:id',
      method: 'GET'
    },
    create: {
      url: '/payment-conditions',
      method: 'POST'
    },
    update: {
      url: '/payment-conditions/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/payment-conditions',
      method: 'DELETE'
    }
  },
  periods: {
    getAll: {
      url: '/periods',
      method: 'GET'
    },
    placementInfo: {
      url: '/periods/placement-info',
      method: 'GET'
    },
    getOne: {
      url: '/periods/:id',
      method: 'GET'
    },
    availability: {
      url: '/periods/availability',
      method: 'GET'
    },
    availabilities: {
      url: '/periods/availability/all',
      method: 'GET'
    },
    create: {
      url: '/periods',
      method: 'POST'
    },
    update: {
      url: '/periods/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/periods/:id',
      method: 'DELETE'
    }
  },
  centers: {
    getAll: {
      url: '/centers',
      method: 'GET'
    },
    get: {
      url: '/centers/:id',
      method: 'GET'
    },
    getActions: {
      url: '/centers/:id/actions',
      method: 'GET'
    },
    create: {
      url: '/centers',
      method: 'POST'
    },
    update: {
      url: '/centers/:id',
      method: 'PATCH'
    },
    createAndAssignJourneys: {
      url: '/centers/create-and-assign-journeys',
      method: 'POST'
    },
    requestStaffs: {
      url: '/centers/request-staffs',
      method: 'POST'
    },
    assignJourneys: {
      url: '/centers/:id/assign-journeys',
      method: 'POST'
    },
    updateAssignedJourneys: {
      url: '/centers/:id/assign-journeys',
      method: 'PATCH'
    },
    getManager: {
      url: '/centers/:id/manager',
      method: 'GET'
    },
    getFacTerrain: {
      url: '/centers/:id/fac-terrain',
      method: 'GET'
    },
    getCenterAccomodation: {
      url: '/centers/:id/accomodation',
      method: 'GET'
    },
    getGenderDistribution: {
      url: '/centers/:id/gender-distribution',
      method: 'GET'
    },
    getAgeDistribution: {
      url: '/centers/:id/age-distribution',
      method: 'GET'
    },
    getFamilyArrangementDistribution: {
      url: '/centers/:id/family-arrangement-distribution',
      method: 'GET'
    },
    getFamilyAssignmentDistribution: {
      url: '/centers/:id/family-assignment-distribution',
      method: 'GET'
    },
    getCenterOl: {
      url: '/centers/:id/ol',
      method: 'GET'
    },
    getSchoolLevelDistribution: {
      url: '/centers/:id/school-level-distribution',
      method: 'GET'
    },
    hasEnrollmentCenter: {
      url: '/centers/:id/has-enrollment-center',
      method: 'GET'
    },
    exportEnrollmentsHealth: {
      url: '/centers/:id/export-enrollments-health',
      method: 'POST'
    },
    printFullListOfEnrollments: {
      url: '/centers/:id/print-full-list-of-enrollments',
      method: 'POST'
    },
    getEnrollmentsPickupListCount: {
      url: '/centers/:id/enrollments-pickup-list/count',
      method: 'GET'
    },
    printEnrollmentsPickupList: {
      url: '/centers/:id/print-enrollments-pickup-list',
      method: 'GET'
    },
    printCallList: {
      url: '/centers/:id/print-call-list',
      method: 'GET'
    },
    printCallLists: {
      url: '/centers/print-call-lists',
      method: 'GET'
    },
    printEnrollmentsIdPictures: {
      url: '/centers/:id/print-enrollments-id-pictures',
      method: 'POST'
    },
    getMainTripDistribution: {
      url: '/centers/:id/main-trip-distribution',
      method: 'GET'
    },
    getSecondaryTripDistribution: {
      url: '/centers/:id/secondary-trip-distribution',
      method: 'GET'
    },
    getJourneyDistribution: {
      url: '/centers/:id/journey-distribution',
      method: 'GET'
    },
    assignLecResponsable: {
      url: '/centers/assign-lec-responsable',
      method: 'POST'
    },
    getCenterJourneys: {
      url: '/centers/:id/journeys',
      method: 'GET'
    },
    getCenterOlJourneyPlace: {
      url: '/centers/:id/ol-journey-place',
      method: 'GET'
    },
    computeTripsMinMaxCapacity: {
      url: '/centers/compute-trips-min-max-capacity',
      method: 'POST'
    },
    suggestTripPlaceValues: {
      url: '/centers/suggest-trip-places-values',
      method: 'POST'
    },
    exportExcel: {
      url: '/centers/export-excel',
      method: 'POST'
    },
    lock: {
      url: '/centers/:id/lock',
      method: 'POST'
    },
    unlock: {
      url: '/centers/:id/unlock',
      method: 'POST'
    },
    printCenterFinalCosts: {
      url: '/centers/:id/print-final-costs',
      method: 'POST'
    },
    printCenterCosts: {
      url: '/centers/:id/print-costs',
      method: 'POST'
    },
    createCenterProgramDocument: {
      url: '/centers/:id/program-documents',
      method: 'POST'
    },
    deleteCenterProgramDocument: {
      url: '/centers/:id/program-documents/:programDocumentFileId',
      method: 'DELETE'
    },
    getCenterProgramDocuments: {
      url: '/centers/:id/program-documents',
      method: 'GET'
    },
    createCenterExceptionalExpense: {
      url: '/centers/:id/exceptional-expenses',
      method: 'POST'
    },
    deleteCenterExceptionalExpense: {
      url: '/centers/:id/exceptional-expenses/:exceptionalExpenseId',
      method: 'DELETE'
    },
    uploadCenterExceptionalExpenseInvoice: {
      url: '/centers/:id/exceptional-expenses/:centerExceptionalExpenseId/upload-invoice',
      method: 'POST'
    },
    deleteCenterExceptionalExpenseInvoice: {
      url: '/centers/:id/exceptional-expenses/:centerExceptionalExpenseId/delete-invoice',
      method: 'DELETE'
    },
    getCenterTripInfo: {
      url: '/centers/:id/trip-info/:tripId',
      method: 'GET'
    },
    getCenterTotalCosts: {
      url: '/centers/:id/total-costs',
      method: 'GET'
    },
    getEnrollmentsCountByCenterAndGender: {
      url: '/centers/enrollments-count-by-center-and-gender',
      method: 'GET'
    },
    getEnrollments: {
      url: '/centers/:id/enrollments',
      method: 'GET'
    },
    getEnrollmentsAgeCompliance: {
      url: '/centers/:id/enrollments-age-compliance',
      method: 'GET'
    },
    exportEnrollmentsExcel: {
      url: '/centers/:id/enrollments/export-excel',
      method: 'POST'
    },
    exportRosterListExcel: {
      url: '/centers/:id/export-roster-list-excel',
      method: 'POST'
    },
    printPdfListOfEnrollmentsListWithMedicalCondition: {
      url: '/centers/:id/print-enrollments-list-with-medical-condition',
      method: 'POST'
    },
    affectEnrollments: {
      url: '/centers/affect-enrollments',
      method: 'POST'
    },
    removeCenterEnrollments: {
      url: '/centers/:id/remove-enrollments',
      method: 'POST'
    },
    assignMobileNumberToCenter: {
      url: '/centers/:id/assign-mobile-number/:mobileNumberForFrenchLeaderId',
      method: 'POST'
    },
    viewCenterEnrollment: {
      url: '/centers/:id/view-enrollment/:enrollmentId',
      method: 'POST'
    },
    assignHostFamilyToEnrollment: {
      url: '/centers/:id/assign-host-family-to-enrollment/:enrollmentId',
      method: 'POST'
    },
    unassignHostFamilyToEnrollment: {
      url: '/centers/:id/unassign-host-family-to-enrollment/:enrollmentId',
      method: 'POST'
    },
    assignHostFamilyToStaff: {
      url: '/centers/:id/assign-host-family-to-staff/:affectedStaffId',
      method: 'POST'
    },
    unassignHostFamilyToStaff: {
      url: '/centers/:id/unassign-host-family-to-staff/:affectedStaffId',
      method: 'POST'
    },
    changeEnrollmentHostFamily: {
      url: '/centers/:id/change-enrollment-host-family/:enrollmentId',
      method: 'POST'
    },
    changeStaffHostFamily: {
      url: '/centers/:id/change-staff-host-family/:affectedStaffId',
      method: 'POST'
    },
    createCenterLecComment: {
      url: '/centers/:centerId/lec-comments',
      method: 'POST'
    },
    getCenterLecComments: {
      url: '/centers/:centerId/lec-comments',
      method: 'GET'
    },
    updateCenterLecComment: {
      url: '/centers/:centerId/lec-comments/:id',
      method: 'PATCH'
    },
    deleteCenterLecComments: {
      url: '/centers/:centerId/lec-comments',
      method: 'DELETE'
    },
    createCenterOlComment: {
      url: '/centers/:centerId/ol-comments',
      method: 'POST'
    },
    getCenterOlComments: {
      url: '/centers/:centerId/ol-comments',
      method: 'GET'
    },
    updateCenterOlComment: {
      url: '/centers/:centerId/ol-comments/:id',
      method: 'PATCH'
    },
    deleteCenterOlComments: {
      url: '/centers/:centerId/ol-comments',
      method: 'DELETE'
    },
    diffuseTripBookings: {
      url: '/centers/diffuse-trip-bookings',
      method: 'POST'
    },
    diffuseEnrollments: {
      url: '/centers/diffuse-enrollments',
      method: 'POST'
    },
    diffuseHostFamilies: {
      url: '/centers/:id/diffuse-host-families',
      method: 'POST'
    },
    diffuseCenterManager: {
      url: '/centers/:id/diffuse-center-manager',
      method: 'POST'
    },
    diffuseEndOfStayAppreciations: {
      url: '/centers/diffuse-end-of-stay-appreciations',
      method: 'POST'
    },
    getEndOfJourneyReviews: { url: '/centers/:id/end-of-journey-reviews', method: 'GET' },
    exportEndOfJourneyReviewsExcel: {
      url: '/centers/:id/end-of-journey-reviews/export-excel',
      method: 'GET'
    },
    printPdfListOfEnrollmentsPlacementByHostFamily: {
      url: '/centers/:id/print-list-of-enrollments-placement-by-host-family',
      method: 'POST'
    },
    printPdfListOfPlacementsByEnrollmentName: {
      url: '/centers/:id/print-list-of-placements-by-enrollment-name',
      method: 'POST'
    },
    printPdfListOfEnrollmentsListByProgram: {
      url: '/centers/:id/print-enrollments-list-by-program',
      method: 'POST'
    },
    printPdfListOfEnrollmentsListBySubGroup: {
      url: '/centers/:id/print-enrollments-list-by-sub-group',
      method: 'GET'
    },
    printEnrollmentsListByMeansOfTransport: {
      url: '/centers/:id/print-enrollments-list-by-means-of-transport',
      method: 'POST'
    },
    printCenterActivityProgram: {
      url: '/centers/:id/print-activity-program',
      method: 'POST'
    },
    printCenterActivityProgramWithBudget: {
      url: '/centers/:id/print-activity-program-with-budget',
      method: 'POST'
    },
    printCenterlevelTests: {
      url: '/centers/:id/print-level-tests',
      method: 'POST'
    },
    downloadCenterLevelTestsExcel: {
      url: '/centers/:id/download-level-tests-excel',
      method: 'POST'
    },
    printCenterLevelTestsResults: {
      url: '/centers/:id/print-level-tests-results',
      method: 'POST'
    },
    printCenterDetailedTestsResults: {
      url: '/centers/:id/print-detailed-tests-results',
      method: 'POST'
    },
    getCenterTripBookings: {
      url: '/centers/:id/trip-bookings',
      method: 'GET'
    },
    getCenterTrips: {
      url: '/centers/:id/trips',
      method: 'GET'
    },
    getCenterTripBookingsTrips: {
      url: '/centers/:id/trip-bookings/trips',
      method: 'GET'
    },
    assignCoachCompany: {
      url: '/centers/:id/assign-coach-company-to-trip-booking',
      method: 'POST'
    },
    sendEnrollmentsToHostFamily: {
      url: '/centers/:id/send-enrollments-to-host-family',
      method: 'POST'
    },
    acknowledgeEnrollmentRemoval: {
      url: '/centers/:id/acknowledge-enrollment-removal/:enrollmentId',
      method: 'POST'
    },
    getCenterLocalOrganizers: {
      url: '/centers/:id/local-organizers',
      method: 'GET'
    },
    updateCenterLocalOrganizers: {
      url: '/centers/:id/local-organizers',
      method: 'PATCH'
    },
    lockCenterLocalOrganizers: {
      url: '/centers/:id/local-organizers/lock',
      method: 'POST'
    },
    unlockCenterLocalOrganizers: {
      url: '/centers/:id/local-organizers/unlock',
      method: 'POST'
    },
    getCenterCostsView: {
      url: '/centers/:id/costs-view',
      method: 'GET'
    },
    getCenterExceptionalExpenses: {
      url: '/centers/:id/exceptional-expenses',
      method: 'GET'
    },
    updateCenterExceptionalExpenses: {
      url: '/centers/:id/exceptional-expenses',
      method: 'PATCH'
    },
    lockCenterExceptionalExpenses: {
      url: '/centers/:id/exceptional-expenses/lock',
      method: 'POST'
    },
    unlockCenterExceptionalExpenses: {
      url: '/centers/:id/exceptional-expenses/unlock',
      method: 'POST'
    },
    sendCostsToLec: {
      url: '/centers/:id/send-costs-to-lec',
      method: 'POST'
    },
    getCenterCulturalOutings: {
      url: '/centers/:id/cultural-outings',
      method: 'GET'
    },
    updateCenterCulturalOuting: {
      url: '/centers/:id/cultural-outings/:centerCulturalOutingId',
      method: 'PATCH'
    },
    updateCenterCulturalOutings: {
      url: '/centers/:id/cultural-outings',
      method: 'PATCH'
    },
    lockCenterCulturalOutings: {
      url: '/centers/:id/cultural-outings/lock',
      method: 'POST'
    },
    unlockCenterCulturalOutings: {
      url: '/centers/:id/cultural-outings/unlock',
      method: 'POST'
    },
    uploadCenterCulturalOutingInvoice: {
      url: '/centers/:id/cultural-outings/:culturalOutingId/upload-invoice',
      method: 'POST'
    },
    deleteCenterCulturalOutingInvoice: {
      url: '/centers/:id/cultural-outings/:culturalOutingId/delete-invoice',
      method: 'DELETE'
    },
    getCenterArrivalDepartureTransfers: {
      url: '/centers/:id/arrival-departure-transfers',
      method: 'GET'
    },
    updateCenterArrivalDepartureTransfers: {
      url: '/centers/:id/arrival-departure-transfers',
      method: 'PATCH'
    },
    lockCenterArrivalDepartureTransfers: {
      url: '/centers/:id/arrival-departure-transfers/lock',
      method: 'POST'
    },
    unlockCenterArrivalDepartureTransfers: {
      url: '/centers/:id/arrival-departure-transfers/unlock',
      method: 'POST'
    },
    uploadCenterArrivalDepartureTransferInvoice: {
      url: '/centers/:id/arrival-departure-transfers/:arrivalDepartureTransferId/upload-invoice',
      method: 'POST'
    },
    deleteCenterArrivalDepartureTransferInvoice: {
      url: '/centers/:id/arrival-departure-transfers/:arrivalDepartureTransferId/delete-invoice',
      method: 'DELETE'
    },
    getCenterHostFamilyCosts: {
      url: '/centers/:id/host-family-costs',
      method: 'GET'
    },
    lockCenterHostFamilyCosts: {
      url: '/centers/:id/host-family-costs/lock',
      method: 'POST'
    },
    unlockCenterHostFamilyCosts: {
      url: '/centers/:id/host-family-costs/unlock',
      method: 'POST'
    },
    updateCenterHostFamilyCosts: {
      url: '/centers/:id/host-family-costs',
      method: 'PATCH'
    },
    validateCenterCosts: {
      url: '/centers/:id/validate-costs',
      method: 'POST'
    },
    openCenterCosts: {
      url: '/centers/:id/open-costs',
      method: 'POST'
    },
    syncCenterCosts: {
      url: '/centers/:id/sync-costs',
      method: 'POST'
    },
    getCenterTeachingHallCosts: {
      url: '/centers/:id/teaching-hall-costs',
      method: 'GET'
    },
    updateCenterTeachingHallCosts: {
      url: '/centers/:id/teaching-hall-costs',
      method: 'POST'
    },
    lockCenterTeachingHallCosts: {
      url: '/centers/:id/teaching-hall-costs/lock',
      method: 'POST'
    },
    unlockCenterTeachingHallCosts: {
      url: '/centers/:id/teaching-hall-costs/unlock',
      method: 'POST'
    },
    getCenterTeflCosts: {
      url: '/centers/:id/tefl-costs',
      method: 'GET'
    },
    updateCenterTeflCosts: {
      url: '/centers/:id/tefl-costs',
      method: 'PATCH'
    },
    lockCenterTeflCosts: {
      url: '/centers/:id/tefl-costs/lock',
      method: 'POST'
    },
    unlockCenterTeflCosts: {
      url: '/centers/:id/tefl-costs/unlock',
      method: 'POST'
    },
    uploadCenterTeflCostInvoice: {
      url: '/centers/:id/tefl-costs/:teflCostId/upload-invoice',
      method: 'POST'
    },
    deleteCenterTeflCostInvoice: {
      url: '/centers/:id/tefl-costs/:teflCostId/delete-invoice/:invoiceId',
      method: 'DELETE'
    },
    getCenterCourses: {
      url: '/centers/:id/courses',
      method: 'GET'
    },
    getCenterActivities: {
      url: '/centers/:id/activities',
      method: 'GET'
    },
    lockCenterActivities: {
      url: '/centers/:id/activities/lock',
      method: 'POST'
    },
    unlockCenterActivities: {
      url: '/centers/:id/activities/unlock',
      method: 'POST'
    },
    uploadCenterActivityInvoice: {
      url: '/centers/:id/activities/:centerActivityId/upload-invoice',
      method: 'POST'
    },
    deleteCenterActivityInvoice: {
      url: '/centers/:id/activities/:centerActivityId/delete-invoice',
      method: 'DELETE'
    },
    generateCenterCourses: {
      url: '/centers/:id/generate-center-courses',
      method: 'POST'
    },
    createCenterCourse: {
      url: '/centers/:id/courses',
      method: 'POST'
    },
    updateCenterCourse: {
      url: '/centers/:centerId/courses/:courseId',
      method: 'PATCH'
    },
    deleteCenterCourse: {
      url: '/centers/:centerId/courses/:courseId',
      method: 'DELETE'
    },
    createCenterActivity: {
      url: '/centers/:centerId/activities',
      method: 'POST'
    },
    updateCenterActivity: {
      url: '/centers/:centerId/activities/:centerActivityId',
      method: 'PATCH'
    },
    deleteCenterActivity: {
      url: '/centers/:centerId/activities/:centerActivityId',
      method: 'DELETE'
    },
    getCenterLocalTransport: {
      url: '/centers/:id/local-transport',
      method: 'GET'
    },
    updateCenterLocalTransport: {
      url: '/centers/:id/local-transport',
      method: 'PATCH'
    },
    getCenterBudget: {
      url: '/centers/:id/budgets',
      method: 'GET'
    },
    getCenterTefls: {
      url: '/centers/:id/tefls',
      method: 'GET'
    },
    getCenterTeam: {
      url: '/centers/:id/team',
      method: 'GET'
    },
    assignCenterTefl: {
      url: '/centers/:id/tefls/assign-tefl',
      method: 'POST'
    },
    unassignCenterTefl: {
      url: '/centers/:id/tefls/unassign-tefl',
      method: 'POST'
    },
    getCenterTeachingHalls: {
      url: '/centers/:id/teaching-halls',
      method: 'GET'
    },
    sendFinalCostsToLec: {
      url: '/centers/:id/send-final-costs-to-lec',
      method: 'POST'
    },
    getCenterCostMissingDocuments: {
      url: '/centers/:id/cost-missing-documents',
      method: 'GET'
    },
    validateFinalCosts: {
      url: '/centers/:id/validate-final-costs',
      method: 'POST'
    },
    openFinalCosts: {
      url: '/centers/:id/open-final-costs',
      method: 'POST'
    },
    uploadCenterTeachingHallInvoice: {
      url: '/centers/:id/teaching-hall-costs/:teachingHallCostId/upload-invoice',
      method: 'POST'
    },
    deleteCenterTeachingHallInvoice: {
      url: '/centers/:id/teaching-hall-costs/:teachingHallCostId/delete-invoice',
      method: 'DELETE'
    },
    getCenterRemainingTeachingHalls: {
      url: '/centers/:id/teaching-hall-remaining-places',
      method: 'GET'
    },
    assignTeachingHall: {
      url: '/centers/:id/teaching-halls/:teachingHallId/assign',
      method: 'POST'
    },
    unassignTeachingHall: {
      url: '/centers/:id/teaching-halls/:teachingHallId/unassign',
      method: 'POST'
    },
    openActivities: {
      url: '/centers/:id/open-activities',
      method: 'POST'
    },
    sendActivitiesToLec: {
      url: '/centers/:id/send-activities-to-lec',
      method: 'POST'
    },
    validateActivities: {
      url: '/centers/:id/validate-activities',
      method: 'POST'
    },
    getCenterFinalCostVisibility: {
      url: '/centers/:id/final-costs/visibility',
      method: 'GET'
    },
    getCenterCurrency: {
      url: '/centers/:id/currency',
      method: 'GET'
    },
    getCenterGroups: {
      url: '/centers/:id/center-groups',
      method: 'GET'
    },
    getCenterGroup: {
      url: '/centers/:id/center-groups/:groupId',
      method: 'GET'
    },
    createCenterGroup: {
      url: '/centers/:id/center-groups',
      method: 'POST'
    },
    updateCenterGroup: {
      url: '/centers/:id/center-groups/:groupId',
      method: 'PATCH'
    },
    deleteCenterGroup: {
      url: '/centers/:id/center-groups/:groupId',
      method: 'DELETE'
    },
    assignTeflToCenterGroup: {
      url: '/centers/:id/center-groups/:groupId/assign-tefl',
      method: 'POST'
    },
    unassignTeflFromCenterGroup: {
      url: '/centers/:id/center-groups/:groupId/unassign-tefl',
      method: 'DELETE'
    },
    getCenterGroupDocuments: {
      url: '/centers/:id/center-groups/:groupId/documents',
      method: 'GET'
    },
    uploadCenterGroupDocument: {
      url: '/centers/:id/center-groups/:groupId/documents',
      method: 'POST'
    },
    deleteCenterGroupDocument: {
      url: '/centers/:id/center-groups/:groupId/documents/:documentId',
      method: 'DELETE'
    },
    getCenterGroupEnrollments: {
      url: '/centers/:id/center-groups/:groupId/enrollments',
      method: 'GET'
    },
    assignEnrollmentsToCenterGroup: {
      url: '/centers/:id/center-groups/:groupId/assign-enrollments',
      method: 'POST'
    },
    unassignEnrollmentFromCenterGroup: {
      url: '/centers/:id/center-groups/:groupId/unassign-enrollments/:enrollmentCenterId',
      method: 'DELETE'
    }
  },
  enrollmentCenters: {
    getEnrollmentCenters: {
      url: '/enrollment-centers',
      method: 'GET'
    }
  },
  centerEvents: {
    getAll: {
      url: '/center-events',
      method: 'GET'
    },
    get: {
      url: '/center-events/:id',
      method: 'GET'
    },
    create: {
      url: '/center-events',
      method: 'POST'
    },
    assign: {
      url: '/center-events/:id/assign',
      method: 'POST'
    },
    resolve: {
      url: '/center-events/:id/resolve',
      method: 'POST'
    },
    createCenterEventAction: {
      url: '/center-events/:id/actions',
      method: 'POST'
    },
    getCenterEventActions: {
      url: '/center-events/:id/actions',
      method: 'GET'
    },
    printPdf: {
      url: '/center-events/:id/print-pdf',
      method: 'GET'
    }
  },
  contractTemplate: {
    getAll: {
      url: '/contract-templates',
      method: 'GET'
    },
    get: {
      url: '/contract-templates/:id',
      method: 'GET'
    },
    activate: {
      url: '/contract-templates/activate',
      method: 'PATCH'
    },
    deactivate: {
      url: '/contract-templates/deactivate',
      method: 'PATCH'
    },
    create: {
      url: '/contract-templates',
      method: 'POST'
    },
    update: {
      url: '/contract-templates/:id',
      method: 'PATCH'
    }
  },
  staffCommentSubjects: {
    getAll: {
      url: '/staff-comment-subjects',
      method: 'GET'
    },
    create: {
      url: '/staff-comment-subjects',
      method: 'POST'
    },
    update: {
      url: '/staff-comment-subjects/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/staff-comment-subjects/:id',
      method: 'DELETE'
    }
  },
  travelCompanies: {
    getAll: {
      url: '/travel-companies',
      method: 'GET'
    },
    create: {
      url: '/travel-companies',
      method: 'POST'
    },
    update: {
      url: '/travel-companies/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/travel-companies/:id',
      method: 'DELETE'
    }
  },
  formulas: {
    getAll: {
      url: '/formulas',
      method: 'GET'
    },
    get: {
      url: '/formulas/:id',
      method: 'GET'
    },
    create: {
      url: '/formulas',
      method: 'POST'
    },
    update: {
      url: '/formulas/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/formulas/:id',
      method: 'DELETE'
    },
    exportExcel: {
      url: '/formulas/export-excel',
      method: 'POST'
    }
  },
  options: {
    getAll: {
      url: '/options',
      method: 'GET'
    },
    get: {
      url: '/options/:id',
      method: 'GET'
    },
    create: {
      url: '/options',
      method: 'POST'
    },
    update: {
      url: '/options/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/options/:id',
      method: 'DELETE'
    },
    exportExcel: {
      url: '/options/export-excel',
      method: 'POST'
    },
    duplicate: {
      url: '/options/:id/duplicate',
      method: 'POST'
    },
    getProductDatePrice: {
      url: '/options/:id/product-dates/:dateId/price',
      method: 'GET'
    },
    getOptionPriceSuggestion: {
      url: '/options/:id/option-price-suggestion',
      method: 'GET'
    }
  },
  optionPrices: {
    getAll: {
      url: '/option-prices',
      method: 'GET'
    },
    get: {
      url: '/option-prices/:id',
      method: 'GET'
    },
    create: {
      url: '/option-prices',
      method: 'POST'
    },
    update: {
      url: '/option-prices/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/option-prices',
      method: 'DELETE'
    },
    duplicate: {
      url: '/option-prices/:id/duplicate',
      method: 'POST'
    }
  },

  howDidYouHearAboutUs: {
    getAll: {
      url: '/how-did-you-hear-about-us',
      method: 'GET'
    },
    create: {
      url: '/how-did-you-hear-about-us',
      method: 'POST'
    },
    update: {
      url: '/how-did-you-hear-about-us/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/how-did-you-hear-about-us/:id',
      method: 'DELETE'
    }
  },
  media: {
    getMediaPath: {
      url: '/media/get-media-path',
      method: 'GET'
    },
    initiateUpload: {
      url: '/media/initiate-upload',
      method: 'POST'
    },
    uploadStatus: {
      url: '/media/upload-status/:uploadId',
      method: 'GET'
    },
    getSignedUrl: {
      url: '/media/signed-url/:uploadId',
      method: 'GET'
    }
  },
  missionTrackings: {
    get: {
      url: '/mission-trackings/:id',
      method: 'GET'
    },
    getAll: {
      url: '/mission-trackings',
      method: 'GET'
    },
    getAffectedStaffs: {
      url: '/mission-trackings/:id/affected-staffs',
      method: 'GET'
    },
    update: {
      url: '/mission-trackings/:id',
      method: 'PATCH'
    },
    updateExceptionalBonus: {
      url: '/mission-trackings/:id/exceptional-bonus',
      method: 'PATCH'
    },
    delete: {
      url: '/mission-trackings/:id',
      method: 'DELETE'
    },
    sendEmail: {
      url: '/mission-trackings/send-email',
      method: 'POST'
    },

    sendMissionFriendlyContractReminder: {
      url: '/mission-trackings/friendly-contract-reminder',
      method: 'POST'
    },
    sendMissionFinalContractReminder: {
      url: '/mission-trackings/final-contract-reminder',
      method: 'POST'
    },
    sendMissionFriendlyMissingDocumentsReminder: {
      url: '/mission-trackings/friendly-missing-documents-reminder',
      method: 'POST'
    },
    sendMissionFinalMissingDocumentsReminder: {
      url: '/mission-trackings/final-missing-documents-reminder',
      method: 'POST'
    },
    sendMissionReportReminder: {
      url: '/mission-trackings/report-reminder',
      method: 'POST'
    },
    sendContracts: {
      url: '/mission-trackings/send-contracts',
      method: 'POST'
    },
    exportDpaeXml: {
      url: '/mission-trackings/export-dpae-xml',
      method: 'POST'
    },
    uploadDpaeAcknowledgmentReceipt: {
      url: '/mission-trackings/dpae-acknowledgment-receipt',
      method: 'POST'
    },
    updateMissionToStaff: {
      url: '/mission-trackings/:id/affected-staffs/:missionToStaffId',
      method: 'PATCH'
    },
    getMissionTrackingsSalaries: {
      url: '/mission-trackings/salaries',
      method: 'GET'
    },
    exportMissionTrackingsSalariesToXml: {
      url: '/mission-trackings/salaries/export-xml',
      method: 'POST'
    },
    exportMissionTrackingsSalariesBeforePas: {
      url: '/mission-trackings/salaries/export-salaries-before-pas',
      method: 'POST'
    },
    validateMissionTrackingsSalaries: {
      url: '/mission-trackings/salaries/validate',
      method: 'POST'
    },
    blockMissionTrackingPas: {
      url: '/mission-trackings/:id/block-pas',
      method: 'POST'
    },
    unblockMissionTrackingPas: {
      url: '/mission-trackings/:id/unblock-pas',
      method: 'POST'
    },
    updateMissionTrackingPas: {
      url: '/mission-trackings/:id/pas',
      method: 'PATCH'
    }
  },
  travelExpenses: {
    getAll: {
      url: '/travel-expenses',
      method: 'GET'
    },
    getStaffs: {
      url: '/travel-expenses/staffs',
      method: 'GET'
    },
    getTravelExpensesSalaryStaffs: {
      url: '/travel-expenses/salary-staffs',
      method: 'GET'
    },
    exportStaffsExpensesSalariesToXml: {
      url: '/travel-expenses/export-xml',
      method: 'POST'
    },
    printStaffsExpensesSalaries: {
      url: '/travel-expenses/print-staffs-expenses-salaries',
      method: 'POST'
    },
    validateStaffsExpensesSalaries: {
      url: '/travel-expenses/validate',
      method: 'POST'
    },
    sendEmail: {
      url: '/travel-expenses/send-email-to-staffs',
      method: 'POST'
    }
  },
  missionTypes: {
    get: {
      url: '/mission-types/:id',
      method: 'DELETE'
    },
    getAll: {
      url: '/mission-types',
      method: 'GET'
    },
    create: {
      url: '/mission-types',
      method: 'POST'
    },
    update: {
      url: '/mission-types/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/mission-types',
      method: 'DELETE'
    }
  },
  tripSteps: {
    getAll: {
      url: '/trip-bookings/trip-steps',
      method: 'GET'
    }
  },
  missions: {
    get: {
      url: '/missions/:id',
      method: 'DELETE'
    },
    getAll: {
      url: '/missions',
      method: 'GET'
    },
    update: {
      url: '/missions/:id',
      method: 'PATCH'
    },
    create: {
      url: '/missions',
      method: 'POST'
    },
    delete: {
      url: '/missions',
      method: 'DELETE'
    },
    confirmMission: {
      url: '/missions/:id/confirm',
      method: 'POST'
    },
    confirmMissions: {
      url: '/missions/confirm',
      method: 'POST'
    },
    cancelMission: {
      url: '/missions/:id/cancel',
      method: 'POST'
    },

    // External Staffs
    getAffectedExternalStaffs: {
      url: '/missions/:id/external-staffs',
      method: 'GET'
    },
    addExternalStaffsToMission: {
      url: '/missions/:id/external-staffs',
      method: 'POST'
    },
    includeBudgetToExternalStaff: {
      url: '/missions/:id/external-staffs/:externalStaffId/include-budget',
      method: 'PATCH'
    },
    excludeBudgetToExternalStaff: {
      url: '/missions/:id/external-staffs/:externalStaffId/exclude-budget',
      method: 'PATCH'
    },
    updateBudgetToExternalStaff: {
      url: '/missions/:id/external-staffs/:externalStaffId/budget',
      method: 'PATCH'
    },
    confirmExternalStaff: {
      url: '/missions/:id/external-staffs/:externalStaffId/confirm',
      method: 'POST'
    },
    cancelExternalStaff: {
      url: '/missions/:id/external-staffs/:externalStaffId/cancel',
      method: 'POST'
    },

    // Lec Staffs
    getAffectedLecStaffs: {
      url: '/missions/:id/lec-staffs',
      method: 'GET'
    },
    getMissionLecStaffOptions: {
      url: '/missions/:id/lec-staffs/options',
      method: 'POST'
    },
    addLecStaffsToMission: {
      url: '/missions/:id/lec-staffs',
      method: 'POST'
    },
    includeBudgetToLecStaff: {
      url: '/missions/:id/lec-staffs/:userId/include-budget',
      method: 'PATCH'
    },
    excludeBudgetToLecStaff: {
      url: '/missions/:id/lec-staffs/:userId/exclude-budget',
      method: 'PATCH'
    },
    updateBudgetToLecStaff: {
      url: '/missions/:id/lec-staffs/:userId/budget',
      method: 'PATCH'
    },
    confirmLecStaff: {
      url: '/missions/:id/lec-staffs/:userId/confirm',
      method: 'POST'
    },
    cancelLecStaff: {
      url: '/missions/:id/lec-staffs/:userId/cancel',
      method: 'POST'
    },

    // Staffs
    getMissionStaffOptions: {
      url: '/missions/:id/staffs/options',
      method: 'GET'
    },
    getAffectedStaffs: {
      url: '/missions/:id/staffs',
      method: 'GET'
    },
    addStaffsToMission: {
      url: '/missions/:id/staffs',
      method: 'POST'
    },
    confirmStaff: {
      url: '/missions/:id/staffs/:staffId/confirm',
      method: 'POST'
    },
    cancelStaff: {
      url: '/missions/:id/staffs/:staffId/cancel',
      method: 'POST'
    },

    assignHotelToStaff: {
      url: '/missions/:id/staffs/:staffId/assign-hotel',
      method: 'PATCH'
    },
    unassignHotelToStaff: {
      url: '/missions/:id/staffs/:staffId/unassign-hotel',
      method: 'PATCH'
    },

    assignTicketToStaff: {
      url: '/missions/:id/staffs/:staffId/assign-ticket',
      method: 'PATCH'
    },
    unassignTicketToStaff: {
      url: '/missions/:id/staffs/:staffId/unassign-ticket',
      method: 'PATCH'
    },
    includeBudgetToStaff: {
      url: '/missions/:id/staffs/:staffId/include-budget',
      method: 'PATCH'
    },
    excludeBudgetToStaff: {
      url: '/missions/:id/staffs/:staffId/exclude-budget',
      method: 'PATCH'
    },
    updateBudgetToStaff: {
      url: '/missions/:id/staffs/:staffId/budget',
      method: 'PATCH'
    }
  },
  pcrPayScale: {
    getAll: {
      url: '/pcr-pay-scales',
      method: 'GET'
    },
    get: {
      url: '/pcr-pay-scales/:id',
      method: 'GET'
    },
    create: {
      url: '/pcr-pay-scales',
      method: 'POST'
    },
    update: {
      url: '/pcr-pay-scales/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/pcr-pay-scales/:id'
    }
  },
  hobbies: {
    getAll: {
      url: '/hobbies',
      method: 'GET'
    },
    create: {
      url: '/hobbies',
      method: 'POST'
    },
    update: {
      url: '/hobbies/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/hobbies/:id'
    }
  },
  enrollmentCharacteristics: {
    getAll: {
      url: '/enrollment-characteristics',
      method: 'GET'
    },
    create: {
      url: '/enrollment-characteristics',
      method: 'POST'
    },
    update: {
      url: '/enrollment-characteristics/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/enrollment-characteristics'
    }
  },
  howDidYouObtainLECBrochure: {
    getAll: {
      url: '/how-did-you-obtain-lec-brochures',
      method: 'GET'
    },
    create: {
      url: '/how-did-you-obtain-lec-brochures',
      method: 'POST'
    },
    update: {
      url: '/how-did-you-obtain-lec-brochures/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/how-did-you-obtain-lec-brochures'
    }
  },
  guides: {
    getAll: {
      url: '/guides',
      method: 'GET'
    },
    get: {
      url: '/guides/:id',
      method: 'GET'
    },
    create: {
      url: '/guides',
      method: 'POST'
    },
    update: {
      url: '/guides/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/guides/:id',
      method: 'DELETE'
    }
  },
  selectedEnrollment: {
    get: {
      url: '/enrollments/current',
      method: 'GET'
    },
    set: {
      url: '/enrollments/current/:id',
      method: 'POST'
    },
    clear: {
      url: '/enrollments/current',
      method: 'DELETE'
    }
  },
  enrollments: {
    getAll: {
      url: '/enrollments',
      method: 'GET'
    },
    get: {
      url: '/enrollments/:id',
      method: 'GET'
    },
    getDistribution: {
      url: '/enrollments/distribution',
      method: 'GET'
    },
    getStatusesDistribution: {
      url: '/enrollments/statuses-distribution',
      method: 'GET'
    },
    getOtoIndividualEnrollmentsOfPeriod: {
      url: '/enrollments/oto-individual-by-period/:periodId',
      method: 'GET'
    },
    generateOtoIndividualStudentsAndTransfersPdf: {
      url: '/enrollments/oto-individual-by-period/:periodId/students-and-transfers-pdf',
      method: 'GET'
    },
    diffuseOtoIndividualPropositionsToOl: {
      url: '/enrollments/oto-individual/diffuse-to-ol',
      method: 'POST'
    },
    diffuseOtoIndividualHostFamiliesToParents: {
      url: '/enrollments/oto-individual/diffuse-host-families-to-parents',
      method: 'POST'
    },
    diffuseOtoIndividualEndOfStayAppreciations: {
      url: '/enrollments/oto-individual/diffuse-end-of-stay-appreciations',
      method: 'POST'
    },
    diffuseOtoIndividualPeriodsEndOfStayAppreciations: {
      url: '/enrollments/oto-individual-by-period/diffuse-end-of-stay-appreciations',
      method: 'POST'
    },
    getEndOfJourneyReviews: { url: '/enrollments/:id/end-of-journey-reviews', method: 'GET' },
    sendOtoIndividualEnrollmentsToHostFamily: {
      url: '/enrollments/oto-individual/send-enrollments-to-host-family',
      method: 'POST'
    },
    acknowledgeOtoIndividualEnrollmentRemoval: {
      url: '/enrollments/oto-individual/:enrollmentId/acknowledge-removal',
      method: 'POST'
    },
    viewOtoIndividualEnrollment: {
      url: '/enrollments/oto-individual/:enrollmentId/view',
      method: 'POST'
    },
    create: {
      url: '/enrollments',
      method: 'POST'
    },
    getCseRegistration: {
      url: '/enrollments/:id/cse-registration',
      method: 'GET'
    },
    doesCseApplyToProposition: {
      url: '/enrollments/:id/cse-registration/:propositionId/is-related',
      method: 'GET'
    },
    generateConfirmationInvoice: {
      url: '/enrollments/:id/generate-confirmation-invoice',
      method: 'GET'
    },
    generateParticipationInvoice: {
      url: '/enrollments/:id/generate-participation-invoice',
      method: 'GET'
    },
    generatePaidInvoice: {
      url: '/enrollments/:id/generate-paid-invoice',
      method: 'GET'
    },
    generateCancellationInvoice: {
      url: '/enrollments/:id/generate-cancellation-invoice',
      method: 'GET'
    },
    addCse: {
      url: '/enrollments/:id/add-cse',
      method: 'POST'
    },
    removeCse: {
      url: '/enrollments/:id/remove-cse',
      method: 'POST'
    },
    sendToCse: {
      url: '/enrollments/:id/send-to-cse',
      method: 'POST'
    },
    acceptCse: {
      url: '/enrollments/:id/accept-cse',
      method: 'POST'
    },
    rejectCse: {
      url: '/enrollments/:id/reject-cse',
      method: 'POST'
    },
    getStatus: {
      url: '/enrollments/:id/status',
      method: 'GET'
    },
    getTermsAndConditions: {
      url: '/enrollments/:id/terms-and-conditions',
      method: 'GET'
    },
    update: {
      url: '/enrollments/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/enrollments'
    },
    sendEmail: {
      url: '/enrollments/send-email-to-parents',
      method: 'POST'
    },
    exportExcel: {
      url: '/enrollments/export-excel',
      method: 'POST'
    },
    getEnrollmentActions: {
      url: '/enrollments/:id/actions',
      method: 'GET'
    },
    connect: {
      url: '/enrollments/:id/connect',
      method: 'POST'
    },
    assignEnrollmentsToAdviser: {
      url: '/enrollments/assign-to-adviser',
      method: 'POST'
    },
    getAdvisors: {
      url: '/enrollments/advisors',
      method: 'GET'
    },
    createProposition: {
      url: '/enrollments/:id/propositions',
      method: 'POST'
    },
    createOtoIndividualProposition: {
      url: '/enrollments/:id/propositions/oto-individual',
      method: 'POST'
    },
    updateOtoIndividualProposition: {
      url: '/enrollments/:id/propositions/oto-individual',
      method: 'PATCH'
    },
    assignOtoIndividualHostFamily: {
      url: '/enrollments/:id/propositions/oto-individual/assign-host-family/:hostFamilyId',
      method: 'POST'
    },
    unassignOtoIndividualHostFamily: {
      url: '/enrollments/:id/propositions/oto-individual/unassign-host-family',
      method: 'POST'
    },
    changeOtoIndividualHostFamily: {
      url: '/enrollments/:id/propositions/oto-individual/change-host-family/:hostFamilyId',
      method: 'POST'
    },
    clearPromoCode: {
      url: '/enrollments/:id/propositions/:propositionId/clear-promo-code',
      method: 'PATCH'
    },
    deleteProposition: {
      url: '/enrollments/:id/propositions/:propositionId',
      method: 'DELETE'
    },
    acceptProposition: {
      url: '/enrollments/:id/propositions/:propositionId/accept',
      method: 'POST'
    },
    getEnrollmentDispatchPlaces: {
      url: '/enrollments/:id/dispatch-places',
      method: 'GET'
    },
    updateProposition: {
      url: '/enrollments/:id/propositions/:propositionId',
      method: 'PATCH'
    },
    newPropositionState: {
      url: '/enrollments/:id/propositions/:propositionId/new-state',
      method: 'PATCH'
    },
    sendProposition: {
      url: '/enrollments/:id/propositions/:propositionId/send',
      method: 'POST'
    },
    getProposition: {
      url: '/enrollments/:id/propositions/:propositionId',
      method: 'GET'
    },
    preauthorizeOtoIndividual: {
      url: '/enrollments/:id/propositions/oto-individual/preauthorize',
      method: 'POST'
    },
    preauthorize: {
      url: '/enrollments/:id/propositions/:propositionId/preauthorize',
      method: 'POST'
    },
    payInstallment: {
      url: '/enrollments/:id/pay-installment',
      method: 'POST'
    },
    payInstantInstallment: {
      url: '/enrollments/:id/pay-instant-installment/:paymentRecordId',
      method: 'POST'
    },
    payBalance: {
      url: '/enrollments/:id/pay-balance',
      method: 'POST'
    },
    getEnrollmentHealth: {
      url: '/enrollments/:id/health',
      method: 'GET'
    },
    updateEnrollmentHealth: {
      url: '/enrollments/:id/health',
      method: 'PATCH'
    },
    canAccessEnrollmentHealth: {
      url: '/enrollments/:id/health/can-access',
      method: 'GET'
    },
    confirmEnrollment: {
      url: '/enrollments/:id/confirm',
      method: 'POST'
    },
    registerEnrollment: {
      url: '/enrollments/:id/register',
      method: 'POST'
    },
    getEnrollmentGuide: {
      url: '/enrollments/:id/guide',
      method: 'GET'
    },
    cancelEnrollment: {
      url: '/enrollments/:id/cancel',
      method: 'POST'
    },
    refundEnrollment: {
      url: '/enrollments/:id/refund',
      method: 'POST'
    },
    tariffAdjustment: {
      url: '/enrollments/:id/propositions/:propositionId/tariff-adjustments',
      method: 'POST'
    },
    getEnrollmentPickup: {
      url: '/enrollments/:id/pickup',
      method: 'GET'
    },
    updateEnrollmentPickup: {
      url: '/enrollments/:id/pickup',
      method: 'PATCH'
    },
    openEnrollmentPickup: {
      url: '/enrollments/:id/pickup/open',
      method: 'POST'
    },
    getEnrollmentPickupPersonInfo: {
      url: '/enrollments/:id/pickup/person-info',
      method: 'GET'
    },
    updateOtoIndividualTransferPerson: {
      url: '/enrollments/:id/oto-individual-transfer-person',
      method: 'PATCH'
    },
    getOtoIndividualTransferPerson: {
      url: '/enrollments/:id/oto-individual-transfer-person',
      method: 'GET'
    },
    getOtoIndividualTransferPersonActions: {
      url: '/enrollments/:id/oto-individual-transfer-person/actions',
      method: 'GET'
    },
    getOtoIndividualTripSteps: {
      url: '/enrollments/:id/oto-individual-trip-steps',
      method: 'GET'
    },
    getOtoIndividualTripStepsActions: {
      url: '/enrollments/:id/oto-individual-trip-steps/actions',
      method: 'GET'
    },
    updateOtoIndividualTripSteps: {
      url: '/enrollments/:id/oto-individual-trip-steps',
      method: 'PATCH'
    },
    getEnrollmentJourneyPreparation: {
      url: '/enrollments/:id/journey-preparation',
      method: 'GET'
    },
    getEnrollmentDepartureChecklist: {
      url: '/enrollments/:id/departure-checklist',
      method: 'GET'
    },
    getEnrollmentAdministrationProcedures: {
      url: '/enrollments/:id/administration-procedures',
      method: 'GET'
    },
    canGoOutAlone: {
      url: '/enrollments/:id/can-go-out-alone',
      method: 'GET'
    },
    getEnrollmentCanAccessJourneyPreparation: {
      url: '/enrollments/:id/can-access-journey-preparation',
      method: 'GET'
    },
    getEnrollmentCanAccessDepartureChecklist: {
      url: '/enrollments/:id/can-access-departure-checklist',
      method: 'GET'
    },
    getEnrollmentCanAccessAdministrationProcedures: {
      url: '/enrollments/:id/can-access-administration-procedures',
      method: 'GET'
    },
    getEnrollmentPickupActions: {
      url: '/enrollments/:id/pickup/actions',
      method: 'GET'
    },
    getClientReservationActions: {
      url: '/enrollments/:id/client-reservation-actions',
      method: 'GET'
    },
    sendEnrollmentQuotaEmail: {
      url: '/enrollments/:id/send-quota',
      method: 'POST'
    },
    sendEnrollmentPropositionsEmail: {
      url: '/enrollments/:id/send-propositions-email',
      method: 'POST'
    },
    getSimilarEnrollments: {
      url: '/enrollments/:id/similar-enrollments',
      method: 'GET'
    },
    getEnrollmentPropositionPromoCodeApplication: {
      url: '/enrollments/:id/propositions/:propositionId/promocode-application',
      method: 'GET'
    },
    isEnrollmentEnded: {
      url: '/enrollments/:id/is-enrollment-ended',
      method: 'GET'
    },
    getEnrollmentOfficialDocumentsAvailability: {
      url: '/enrollments/:id/official-documents-availability',
      method: 'GET'
    },
    hasTest: {
      url: '/enrollments/:id/has-test',
      method: 'GET'
    },
    getSimilarParentEnrollments: {
      url: '/enrollments/:id/similar-parent-enrollments',
      method: 'GET'
    },
    getEnrollmentEmails: {
      url: '/enrollments/:id/emails',
      method: 'GET'
    },
    getPropositions: {
      url: '/enrollments/:id/propositions',
      method: 'GET'
    },
    getRemindersHistory: {
      url: '/enrollments/:id/reminders-history',
      method: 'GET'
    },
    getMainProposition: {
      url: '/enrollments/:id/propositions/main',
      method: 'GET'
    },
    comparePropositionWithMainProposition: {
      url: '/enrollments/:id/propositions/:propositionId/compare-with-main',
      method: 'GET'
    },
    getPaymentRecords: {
      url: '/enrollments/:id/payment-records',
      method: 'GET'
    },
    activateAutomaticPayments: {
      url: '/enrollments/:id/activate-automatic-payments',
      method: 'GET'
    },
    deactivateAutomaticPayments: {
      url: '/enrollments/:id/deactivate-automatic-payments',
      method: 'GET'
    },
    exportEnrollmentProfilePdf: {
      url: '/enrollments/:id/export-enrollment-profile-pdf',
      method: 'POST'
    },
    exportEnrollmentHealthPdf: {
      url: '/enrollments/:id/export-enrollment-health-pdf',
      method: 'POST'
    },
    exportEnrollmentDetailedLanguageTestResultPdf: {
      url: '/enrollments/:id/export-enrollment-detailed-language-test-result-pdf',
      method: 'POST'
    },
    getPaymentRecordsStatusesStatistics: {
      url: '/enrollments/:id/payment-records/statuses/statistics',
      method: 'GET'
    },
    createPaymentRecord: {
      url: '/enrollments/:id/payment-records',
      method: 'POST'
    },
    updatePaymentRecord: {
      url: '/enrollments/:id/payment-records/:paymentRecordId',
      method: 'PATCH'
    },
    createEnrollmentComment: {
      url: '/enrollments/:id/comments',
      method: 'POST'
    },
    getMedicalAttestation: {
      url: '/enrollments/:id/medical-statement/medical-attestation',
      method: 'GET'
    },
    sendMedicalAttestation: {
      url: '/enrollments/:id/medical-statement/send-attestation',
      method: 'POST'
    },
    resendMedicalAttestation: {
      url: '/enrollments/:id/medical-statement/resend-attestation',
      method: 'POST'
    },
    validateMedicalAttestation: {
      url: '/enrollments/:id/medical-statement/validate-attestation',
      method: 'POST'
    },
    signMedicalAttestation: {
      url: '/enrollments/:id/medical-statement/sign-attestation',
      method: 'POST'
    },
    translateMedicalInformation: {
      url: '/enrollments/:id/medical-statement/translate-medical-information',
      method: 'POST'
    },
    getEnrollmentComments: {
      url: '/enrollments/:id/comments',
      method: 'GET'
    },
    updateEnrollmentComment: {
      url: '/enrollments/:id/comments/:commentId',
      method: 'PATCH'
    },
    updateEnrollmentIdentity: {
      url: '/enrollments/:id/identity',
      method: 'PATCH'
    },
    submitEnrollmentIdentityForUSA: {
      url: '/enrollments/:id/identity/submit-identity-for-usa',
      method: 'POST'
    },
    getEnrollmentIdentity: {
      url: '/enrollments/:id/identity',
      method: 'GET'
    },
    deleteEnrollmentComment: {
      url: '/enrollments/:id/comments/:commentId',
      method: 'DELETE'
    },
    getFriends: {
      url: '/enrollments/:id/friends',
      method: 'GET'
    },
    getEnrollmentSiblings: {
      url: '/enrollments/:id/siblings',
      method: 'GET'
    },
    getEnrollmentPropositionPricing: {
      url: '/enrollments/proposition-pricing',
      method: 'POST'
    },
    getEnrollmentPropositionPricingById: {
      url: '/enrollments/:id/propositions/:propositionId/pricing',
      method: 'GET'
    },
    getOtoIndividualPropositionPricing: {
      url: '/enrollments/oto-individual-proposition-pricing',
      method: 'POST'
    },
    getOtoIndividualPropositionPricingById: {
      url: '/enrollments/:id/propositions/oto-individual/pricing',
      method: 'GET'
    },
    getApplicationFees: {
      url: '/enrollments/application-fees',
      method: 'GET'
    },
    getFamilyDiscount: {
      url: '/enrollments/family-discount',
      method: 'GET'
    },
    getCanGoOutAloneOption: {
      url: '/can-go-out-alone-conditions/option',
      method: 'GET'
    },
    authorizeChildToGoOutAlone: {
      url: '/enrollments/:id/authorize-child-to-go-out-alone',
      method: 'POST'
    },
    unauthorizeChildToGoOutAlone: {
      url: '/enrollments/:id/unauthorize-child-to-go-out-alone',
      method: 'POST'
    },
    acceptGoOutAloneAuthorization: {
      url: '/enrollments/:id/accept-go-out-alone-authorization',
      method: 'POST'
    },
    rejectGoOutAloneAuthorization: {
      url: '/enrollments/:id/reject-go-out-alone-authorization',
      method: 'POST'
    },
    resendAuthorizationToGoOutAlone: {
      url: '/enrollments/:id/resend-authorization-to-go-out-alone',
      method: 'POST'
    },
    cancelEnrollmentRequest: {
      url: '/enrollments/:id/cancel-request',
      method: 'POST'
    },
    getDisplayVersion: {
      url: '/enrollments/:id/display-version',
      method: 'GET'
    },
    getEnrollmentCenter: {
      url: '/enrollments/:id/center',
      method: 'GET'
    },

    getEnrollmentHostFamily: {
      url: '/enrollments/:id/host-family',
      method: 'GET'
    },
    getOtoIndividualLocalRepresentative: {
      url: '/enrollments/:id/oto-individual-local-representative',
      method: 'GET'
    },
    getContactVersion: {
      url: '/enrollments/:id/contact-version',
      method: 'GET'
    },
    getEnrollmentProfileCompletion: {
      url: '/enrollments/:id/profile-completion',
      method: 'GET'
    },
    getEnrollmentProfileCompletionPercentage: {
      url: '/enrollments/:id/profile-completion-percentage',
      method: 'GET'
    },
    getEnrollmentProfileMissingDocuments: {
      url: '/enrollments/:id/profile-missing-documents',
      method: 'GET'
    },
    sendClientSpaceEmailReminder: {
      url: '/enrollments/send-client-space-reminder-by-email',
      method: 'POST'
    },
    sendClientSpacePhoneReminder: {
      url: '/enrollments/send-client-space-reminder-by-phone',
      method: 'POST'
    },
    lockChildInfo: {
      url: '/enrollments/:id/lock-child-info',
      method: 'POST'
    },
    lockIdentityPapers: {
      url: '/enrollments/:id/lock-identity-papers',
      method: 'POST'
    },
    lockHealthPapers: {
      url: '/enrollments/:id/lock-health-papers',
      method: 'POST'
    },
    lockPickup: {
      url: '/enrollments/:id/lock-pickup',
      method: 'POST'
    },
    lockIdentityPicture: {
      url: '/enrollments/:id/lock-identity-picture',
      method: 'POST'
    },
    lockLanguageTest: {
      url: '/enrollments/:id/lock-language-test',
      method: 'POST'
    },

    unlockChildInfo: {
      url: '/enrollments/:id/unlock-child-info',
      method: 'POST'
    },
    unlockIdentityPapers: {
      url: '/enrollments/:id/unlock-identity-papers',
      method: 'POST'
    },
    unlockHealthPapers: {
      url: '/enrollments/:id/unlock-health-papers',
      method: 'POST'
    },
    unlockPickup: {
      url: '/enrollments/:id/unlock-pickup',
      method: 'POST'
    },
    unlockIdentityPicture: {
      url: '/enrollments/:id/unlock-identity-picture',
      method: 'POST'
    },
    unlockLanguageTest: {
      url: '/enrollments/:id/unlock-language-test',
      method: 'POST'
    },
    validateEnrollmentChildInfo: {
      url: '/enrollments/:id/validate-child-info',
      method: 'POST'
    },
    sendCancelNotification: {
      url: '/enrollments/:id/send-cancel-notification',
      method: 'POST'
    },
    sendModificationNotification: {
      url: '/enrollments/:id/send-modification-notification',
      method: 'POST'
    },
    sendRefundNotification: {
      url: '/enrollments/:id/send-refund-notification',
      method: 'POST'
    }
  },
  promoCodes: {
    getAll: {
      url: '/promo-codes',
      method: 'GET'
    },
    get: {
      url: '/promo-codes/:id',
      method: 'GET'
    },
    create: {
      url: '/promo-codes',
      method: 'POST'
    },
    update: {
      url: '/promo-codes/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/promo-codes'
    },
    checkPromoCode: {
      url: '/promo-codes/check',
      method: 'POST'
    }
  },
  aAKeyWords: {
    getAll: {
      url: '/aa-keywords',
      method: 'GET'
    },
    get: {
      url: '/aa-keywords/:id',
      method: 'GET'
    },
    create: {
      url: '/aa-keywords',
      method: 'POST'
    },
    update: {
      url: '/aa-keywords/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/aa-keywords'
    },
    checkAAKeyword: {
      url: '/aa-keywords/check',
      method: 'GET'
    }
  },
  youthAndSportNumbers: {
    getAll: {
      url: '/youth-and-sport-numbers',
      method: 'GET'
    },
    get: {
      url: '/youth-and-sport-numbers/:id',
      method: 'GET'
    },
    create: {
      url: '/youth-and-sport-numbers',
      method: 'POST'
    },
    update: {
      url: '/youth-and-sport-numbers/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/youth-and-sport-numbers'
    }
  },
  medicalTerms: {
    getAll: {
      url: '/medical-terms',
      method: 'GET'
    },
    checkMedicalLevel: {
      url: '/medical-terms/check-medical-level',
      method: 'GET'
    },
    get: {
      url: '/medical-terms/:id',
      method: 'GET'
    },
    create: {
      url: '/medical-terms',
      method: 'POST'
    },
    update: {
      url: '/medical-terms/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/medical-terms'
    }
  },
  transportMeans: {
    getAll: {
      url: '/transport-means',
      method: 'GET'
    },
    create: {
      url: '/transport-means',
      method: 'POST'
    },
    update: {
      url: '/transport-means/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/transport-means/:id'
    }
  },
  accomodationType: {
    getAll: {
      url: '/accomodation-types',
      method: 'GET'
    },
    create: {
      url: '/accomodation-types',
      method: 'POST'
    },
    update: {
      url: '/accomodation-types/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/accomodation-types/:id'
    }
  },
  tripPlaces: {
    getAll: {
      url: '/trip-places',
      method: 'GET'
    },
    create: {
      url: '/trip-places',
      method: 'POST'
    },
    update: {
      url: '/trip-places/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/trip-places/:id',
      method: 'DELETE'
    }
  },
  transferMeal: {
    preview: {
      url: '/transfer-meals/:tripFolderId/preview',
      method: 'POST'
    },
    create: {
      url: '/transfer-meals/:tripFolderId',
      method: 'POST'
    },
    getOrder: {
      url: '/transfer-meals/orders/:id',
      method: 'GET'
    },
    updateOrder: {
      url: '/transfer-meals/orders/:id',
      method: 'PATCH'
    },
    cancelOrder: {
      url: '/transfer-meals/orders/:id/cancel',
      method: 'POST'
    },
    resendOrder: {
      url: '/transfer-meals/orders/:id/resend',
      method: 'POST'
    }
  },
  tripFolder: {
    get: {
      url: '/trip-folders/:id',
      method: 'GET'
    },
    getAll: {
      url: '/trip-folders',
      method: 'GET'
    },
    create: {
      url: '/trip-folders',
      method: 'POST'
    },
    lock: {
      url: '/trip-folders/:id/lock',
      method: 'PATCH'
    },
    unlock: {
      url: '/trip-folders/:id/unlock',
      method: 'PATCH'
    },
    update: {
      url: '/trip-folders/:id',
      method: 'PATCH'
    },
    assignMissions: {
      url: '/trip-folders/:id/missions/assign',
      method: 'POST'
    },
    assignTransfers: {
      url: '/trip-folders/:id/transfers/assign',
      method: 'POST'
    },
    printRollCall: {
      url: '/trip-folders/:id/print-roll-call',
      method: 'GET'
    },
    unassignTransfer: {
      url: '/trip-folders/:id/transfers/:transferId/unassign',
      method: 'POST'
    },
    updateTransfer: {
      url: '/trip-folders/:id/transfers/:transferId',
      method: 'PATCH'
    },
    getMissionToStaffs: {
      url: '/trip-folders/:id/mission-staffs',
      method: 'GET'
    },
    getAffectedStaffs: {
      url: '/trip-folders/:id/affected-staffs',
      method: 'GET'
    },
    getStats: {
      url: '/trip-folders/:id/stats',
      method: 'GET'
    },
    getTransfers: {
      url: '/trip-folders/:id/transfers',
      method: 'GET'
    },
    getTripBookings: {
      url: '/trip-folders/:id/trip-bookings',
      method: 'GET'
    },
    getMissions: {
      url: '/trip-folders/:id/missions',
      method: 'GET'
    },
    getSecondaryTripBookings: {
      url: '/trip-folders/:id/secondary-trip-bookings',
      method: 'GET'
    },
    getOlArrivals: {
      url: '/trip-folders/:id/ol-arrivals',
      method: 'GET'
    },
    unassignMission: {
      url: '/trip-folders/:id/missions/:missionId/unassign',
      method: 'POST'
    },
    getCenters: {
      url: '/trip-folders/:id/centers',
      method: 'GET'
    },
    getDeparturePlaces: {
      url: '/trip-folders/:id/departure-places',
      method: 'GET'
    },
    getEnrollments: {
      url: '/trip-folders/:id/enrollments',
      method: 'GET'
    },
    assignSupervisor: {
      url: '/trip-folders/:id/enrollments/:enrollmentId/assign-supervisor/:supervisorId',
      method: 'POST'
    },
    unassignSupervisor: {
      url: '/trip-folders/:id/enrollments/:enrollmentId/unassign-supervisor',
      method: 'POST'
    },
    getDocuments: {
      url: '/trip-folders/:id/documents',
      method: 'GET'
    },
    createDocument: {
      url: '/trip-folders/:id/documents',
      method: 'POST'
    },
    deleteDocument: {
      url: '/trip-folders/:id/documents/:documentId',
      method: 'DELETE'
    },
    getTripFolderDocuments: {
      url: '/trip-folders/:id/trip-booking-documents',
      method: 'GET'
    },
    generatePdf: {
      url: '/trip-folders/:id/pdf',
      method: 'GET'
    },
    downloadTripFolderEnrollmentsListByReservationPdf: {
      url: '/trip-folders/:id/enrollments-list-pdf/reservation',
      method: 'GET'
    },
    downloadTripFolderEnrollmentsListByCenterPdf: {
      url: '/trip-folders/:id/enrollments-list-pdf/center',
      method: 'GET'
    }
  },
  tripAddresses: {
    getAll: {
      url: '/trip-addresses',
      method: 'GET'
    },
    get: {
      url: '/trip-addresses/:id',
      method: 'GET'
    },
    create: {
      url: '/trip-addresses',
      method: 'POST'
    },
    update: {
      url: '/trip-addresses/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/trip-addresses',
      method: 'DELETE'
    }
  },
  tripBookingDispatchPlaces: {
    getAll: {
      url: '/trip-booking-dispatch-places',
      method: 'GET'
    },
    get: {
      url: '/trip-booking-dispatch-places/:id',
      method: 'GET'
    }
  },
  tripBookingGuidelines: {
    getAll: {
      url: '/trip-booking-guidelines',
      method: 'GET'
    },
    get: {
      url: '/trip-booking-guidelines/:id',
      method: 'GET'
    },
    create: {
      url: '/trip-booking-guidelines',
      method: 'POST'
    },
    update: {
      url: '/trip-booking-guidelines/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/trip-booking-guidelines',
      method: 'DELETE'
    }
  },
  informationRequests: {
    getAll: {
      url: '/information-requests',
      method: 'GET'
    },
    get: {
      url: '/information-requests/:id',
      method: 'GET'
    },
    create: {
      url: '/information-requests',
      method: 'POST'
    },
    update: {
      url: '/information-requests/:id',
      method: 'PATCH'
    },
    printPdfDestineo: {
      url: '/information-requests/print-destineo',
      method: 'POST'
    },
    printPdfStandard: {
      url: '/information-requests/print-standard',
      method: 'POST'
    },
    exportExcel: {
      url: '/information-requests/export-excel',
      method: 'GET'
    },
    delete: {
      url: '/information-requests/:id',
      method: 'DELETE'
    }
  },
  trips: {
    get: {
      url: '/trips/:id',
      method: 'GET'
    },
    getAll: {
      url: '/trips',
      method: 'GET'
    },
    create: {
      url: '/trips',
      method: 'POST'
    },
    update: {
      url: '/trips/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/trips',
      method: 'DELETE'
    },
    getTripTripbookings: {
      url: '/trips/:id/trip-bookings',
      method: 'GET'
    },
    getTripJourneyDates: {
      url: '/trips/journeys-dates',
      method: 'GET'
    },
    unpublishTripsJourneys: {
      url: '/trips/unpublish-journeys',
      method: 'POST'
    },
    getTripPrices: {
      url: '/trips/:id/prices',
      method: 'GET'
    },
    createTripPrice: {
      url: '/trips/:id/prices',
      method: 'POST'
    },
    updateTripPrice: {
      url: '/trips/:id/prices/:priceId',
      method: 'PATCH'
    },
    deleteTripPrice: {
      url: '/trips/:id/prices/:priceId',
      method: 'DELETE'
    },
    exportExcel: {
      url: '/trips/export-excel',
      method: 'POST'
    },
    assignTripGroupingsToTrips: {
      url: '/trips/assign-trip-groupings-to-trips',
      method: 'POST'
    },
    unassignTripGroupingsFromTrip: {
      url: '/trips/:id/unassign-trip-groupings-from-trip',
      method: 'DELETE'
    }
  },

  timezones: {
    getAll: {
      url: '/timezones',
      method: 'GET'
    },
    getTripSteps: {
      url: '/timezones/trip-steps',
      method: 'GET'
    }
  },
  countries: {
    get: {
      url: '/countries/:id',
      method: 'GET'
    },
    getAll: {
      url: '/countries',
      method: 'GET'
    },
    getCountryRequiredDocuments: {
      url: '/countries/:id/required-documents',
      method: 'GET'
    },
    getCountriesList: {
      url: '/countries/list',
      method: 'GET'
    },
    getNationalitiesList: {
      url: '/countries/nationalities',
      method: 'GET'
    },
    getFranceDepartments: {
      url: '/countries/france-departments',
      method: 'GET'
    },
    getFranceCitiesByDepartment: {
      url: '/countries/france-cities-by-department',
      method: 'GET'
    },
    exportExcel: {
      url: '/countries/export-excel',
      method: 'POST'
    },
    create: {
      url: '/countries',
      method: 'POST'
    },
    update: {
      url: '/countries/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/countries',
      method: 'DELETE'
    }
  },
  transfer: {
    get: {
      url: '/transfers/:id',
      method: 'GET'
    },
    getAll: {
      url: '/transfers',
      method: 'GET'
    },
    create: {
      url: '/transfers',
      method: 'POST'
    },
    update: {
      url: '/transfers/:id',
      method: 'PATCH'
    },
    getAllPayments: {
      url: '/transfers/:transferId/payments',
      method: 'GET'
    },
    createPayment: {
      url: '/transfers/:transferId/payments',
      method: 'POST'
    },
    updatePayment: {
      url: '/transfers/:transferId/payments/:id',
      method: 'PATCH'
    },
    deletePayment: {
      url: '/transfers/:transferId/payments/:id',
      method: 'DELETE'
    },
    getAllReminders: {
      url: '/transfers/:transferId/reminders',
      method: 'GET'
    },
    createReminder: {
      url: '/transfers/:transferId/reminders',
      method: 'POST'
    },
    updateReminder: {
      url: '/transfers/:transferId/reminders/:id',
      method: 'PATCH'
    },
    deleteReminder: {
      url: '/transfers/:transferId/reminders/:id',
      method: 'DELETE'
    }
  },
  notifications: {
    getAll: {
      url: '/notifications',
      method: 'GET'
    },
    markNotificationAsRead: {
      url: '/notifications/:id/read',
      method: 'POST',
      queryKeys: ['notification', ':id', 'read']
    },
    markNotificationsAsRead: {
      url: '/notifications/read-all',
      method: 'POST'
    }
  },
  staffRequest: {
    getAll: {
      url: '/staff-requests',
      method: 'GET'
    },
    get: {
      url: '/staff-requests/:id',
      method: 'GET'
    },
    sendEmail: {
      url: '/staff-requests/send-email-to-affected-staffs',
      method: 'POST'
    }
  },
  affectedStaffs: {
    getEndOfJourneyReview: { url: '/affected-staffs/:id/end-of-journey-review', method: 'GET' },
    getAll: {
      url: '/affected-staffs',
      method: 'GET'
    },
    getCenterRequestedStaffSlots: {
      url: '/affected-staffs/center/:centerId/requested-staff-slots',
      method: 'GET'
    },
    getIdDocumentWarnings: {
      url: '/affected-staffs/id-document-warnings',
      method: 'GET'
    },
    getActions: {
      url: '/affected-staffs/:id/actions',
      method: 'GET'
    },
    getForeignTravelSummary: {
      url: '/affected-staffs/:id/foreign-travel-summary',
      method: 'GET'
    },
    update: {
      url: '/affected-staffs/:id',
      method: 'PATCH'
    },
    updateStatus: {
      url: '/affected-staffs/:id/status',
      method: 'PATCH'
    },
    get: {
      url: '/affected-staffs/:id',
      method: 'GET'
    },
    sendAffectedStaffAffectionNotification: {
      url: '/affected-staffs/send-affected-staff-affection-notification',
      method: 'POST'
    },
    sendAffectedStaffDeaffectionNotification: {
      url: '/affected-staffs/send-affected-staff-deaffection-notification',
      method: 'POST'
    },
    sendAffectedStaffReassignmentNotification: {
      url: '/affected-staffs/send-affected-staff-reassignment-notification',
      method: 'POST'
    },
    getAffectedStaffTeachingHalls: {
      url: '/affected-staffs/:id/teaching-halls',
      method: 'GET'
    },
    getRadParticipant: {
      url: '/affected-staffs/:id/rad-participant',
      method: 'GET'
    },
    getAffectedStaffContacts: {
      url: '/affected-staffs/:id/contacts',
      method: 'GET'
    },
    getAffectedStaffEndOfStayReport: {
      url: '/affected-staffs/:id/end-of-stay-report',
      method: 'GET'
    },
    saveAffectedStaffEndOfStayReport: {
      url: '/affected-staffs/:id/end-of-stay-report/save',
      method: 'POST'
    },
    submitAffectedStaffEndOfStayReport: {
      url: '/affected-staffs/:id/end-of-stay-report/submit',
      method: 'POST'
    },
    getAffectedStaffDailyReport: {
      url: '/affected-staffs/:id/daily-report',
      method: 'GET'
    },
    saveAffectedStaffDailyReport: {
      url: '/affected-staffs/:id/daily-report/save',
      method: 'POST'
    },
    submitAffectedStaffDailyReport: {
      url: '/affected-staffs/:id/daily-report/submit',
      method: 'POST'
    },
    create: {
      url: '/affected-staffs',
      method: 'POST'
    },
    getAffectedStaffQuestionnaire: {
      url: '/affected-staffs/:id/questionnaire',
      method: 'GET'
    },
    submitAffectedStaffQuestionnaire: {
      url: '/affected-staffs/:id/questionnaire/submit',
      method: 'POST'
    },
    saveAffectedStaffQuestionnaire: {
      url: '/affected-staffs/:id/questionnaire/save',
      method: 'PUT'
    },
    exportEnrollmentsListByTestGrades: {
      url: '/affected-staffs/:id/export-enrollments-list-by-test-grades',
      method: 'POST'
    },
    exportEnrollmentsListExcel: {
      url: '/affected-staffs/:id/export-enrollments-list-excel',
      method: 'POST'
    },
    printEnrollmentsListWithPhoto: {
      url: '/affected-staffs/:id/print-enrollments-list-with-photo',
      method: 'POST'
    },
    printEnrollmentsListByMeansOfTransport: {
      url: '/affected-staffs/:id/print-enrollments-list-by-means-of-transport',
      method: 'POST'
    },
    printEnrollmentsRegistrationForms: {
      url: '/affected-staffs/:id/print-enrollments-registration-forms',
      method: 'GET'
    },
    affect: {
      url: '/affected-staffs/affect',
      method: 'POST'
    },
    getAffectStaffDispatchPlaces: {
      url: '/affected-staffs/:id/dispatch-places',
      method: 'GET'
    },
    joinGroup: {
      url: '/affected-staffs/:id/dispatch-places/join-group',
      method: 'POST'
    },
    attendAlone: {
      url: '/affected-staffs/:id/dispatch-places/attend-alone',
      method: 'POST'
    },
    reassignStaffRequest: {
      url: '/affected-staffs/:id/reassign-staff-request',
      method: 'POST'
    },
    cancel: {
      url: '/affected-staffs/cancel',
      method: 'POST'
    },
    getAffectedStaffEnrollments: {
      url: '/affected-staffs/:id/enrollments',
      method: 'GET'
    },
    sendFriendlyMissingDocumentsReminderToStaffs: {
      url: '/affected-staffs/send-friendly-missing-documents-reminder',
      method: 'POST'
    },
    sendFriendlyContractReminderToStaffs: {
      url: '/affected-staffs/send-friendly-contract-reminder',
      method: 'POST'
    },
    sendTravelChoiceReminderToStaffs: {
      url: '/affected-staffs/send-travel-choice-reminder',
      method: 'POST'
    },
    sendFinalContractReminderToStaffs: {
      url: '/affected-staffs/send-final-contract-reminder',
      method: 'POST'
    },
    sendFinalMissingDocumentsReminderToStaffs: {
      url: '/affected-staffs/send-final-missing-documents-reminder',
      method: 'POST'
    },
    createOrUpdateTravelExpenses: {
      url: '/affected-staffs/:id/travel-expenses',
      method: 'POST'
    },
    sendTravelExpensesToLEC: {
      url: '/affected-staffs/:id/travel-expenses/send-to-lec',
      method: 'POST'
    },
    validateTravelExpenses: {
      url: '/affected-staffs/:id/travel-expenses/validate',
      method: 'POST'
    },
    openTravelExpenses: {
      url: '/affected-staffs/:id/travel-expenses/open',
      method: 'POST'
    },
    getAffectedStaffTravelExpenses: {
      url: '/affected-staffs/:id/travel-expenses',
      method: 'GET'
    },
    exportDpaeXml: {
      url: '/affected-staffs/export-dpae-xml',
      method: 'POST'
    },
    uploadDpaeAcknowledgmentReceipt: {
      url: '/affected-staffs/dpae-acknowledgment-receipt',
      method: 'POST'
    },
    exportStaffsDiplomasToExcel: {
      url: '/affected-staffs/export-diplomas-excel',
      method: 'POST'
    },
    sendContract: {
      url: '/affected-staffs/:id/send-contract',
      method: 'POST'
    },
    sendContracts: {
      url: '/affected-staffs/send-contracts',
      method: 'POST'
    },
    sendContractReminder: {
      url: '/affected-staffs/:id/send-contract-reminder',
      method: 'POST'
    },
    getReminders: {
      url: '/affected-staffs/:id/reminders',
      method: 'GET'
    },
    sendArrivalChoiceEmail: {
      url: '/affected-staffs/:id/send-arrival-choice-email',
      method: 'POST'
    },
    getGuides: {
      url: '/affected-staffs/:id/guides',
      method: 'GET'
    },
    createTravelExpensesComment: {
      url: '/affected-staffs/:affectedStaffId/travel-expenses-comments',
      method: 'POST'
    },
    getTravelExpensesComments: {
      url: '/affected-staffs/:affectedStaffId/travel-expenses-comments',
      method: 'GET'
    },
    updateTravelExpensesComment: {
      url: '/affected-staffs/:affectedStaffId/travel-expenses-comments/:id',
      method: 'PATCH'
    },
    deleteTravelExpensesComments: {
      url: '/affected-staffs/:affectedStaffId/travel-expenses-comments',
      method: 'DELETE'
    },
    generateEndOfStayReportPdf: {
      url: '/affected-staffs/:id/end-of-stay-report/pdf',
      method: 'POST'
    },
    blockAffectedStaffTravelExpenses: {
      url: '/affected-staffs/:id/block-travel-expenses',
      method: 'POST'
    },
    unblockAffectedStaffTravelExpenses: {
      url: '/affected-staffs/:id/unblock-travel-expenses',
      method: 'POST'
    },
    getAffectedStaffsSalaries: {
      url: '/affected-staffs/salaries',
      method: 'GET'
    },
    exportAffectedStaffsSalariesToXml: {
      url: '/affected-staffs/salaries/export-xml',
      method: 'POST'
    },
    validateAffectedStaffsSalaries: {
      url: '/affected-staffs/salaries/validate',
      method: 'POST'
    },
    blockAffectedStaffPas: {
      url: '/affected-staffs/:id/block-pas',
      method: 'POST'
    },
    unblockAffectedStaffPas: {
      url: '/affected-staffs/:id/unblock-pas',
      method: 'POST'
    },
    exportAffectedStaffsSalariesBeforePasToExcel: {
      url: '/affected-staffs/salaries/export-salaries-before-pas',
      method: 'POST'
    },
    updateAffectedStaffPas: {
      url: '/affected-staffs/:id/pas',
      method: 'PATCH'
    },
    uploadAffectedStaffSalariesExcel: {
      url: '/affected-staffs/salaries/upload-excel',
      method: 'POST'
    },
    updateTravelExpensesCurrency: {
      url: '/affected-staffs/:id/travel-expenses/currency',
      method: 'PATCH'
    },
    diffuseTravelChoices: {
      url: '/affected-staffs/:id/diffuse-travel-choices',
      method: 'POST'
    },
    diffuseHostFamilyAccommodation: {
      url: '/affected-staffs/:id/diffuse-host-family-accommodation',
      method: 'POST'
    },
    diffuseHostFamilyAccommodations: {
      url: '/affected-staffs/diffuse-host-family-accommodations',
      method: 'POST'
    },
    diffuseTravelInformation: {
      url: '/affected-staffs/:id/diffuse-travel-information',
      method: 'POST'
    },
    diffuseTravelInformations: {
      url: '/affected-staffs/diffuse-travel-informations',
      method: 'POST'
    },
    diffuseTeam: {
      url: '/affected-staffs/:id/diffuse-team',
      method: 'POST'
    },
    diffuseTeams: {
      url: '/affected-staffs/diffuse-teams',
      method: 'POST'
    },
    diffuseOlInfos: {
      url: '/affected-staffs/diffuse-ol-infos',
      method: 'POST'
    },
    diffuseCourseLocation: {
      url: '/affected-staffs/:id/diffuse-course-location',
      method: 'POST'
    }
  },
  missionToStaffs: {
    getMissionToStaff: {
      url: '/mission-to-staffs/:id',
      method: 'GET'
    },
    getMissionToStaffMission: {
      url: '/mission-to-staffs/:id/mission',
      method: 'GET'
    },
    getMissionToStaffReport: {
      url: '/mission-to-staffs/:id/report',
      method: 'GET'
    },
    submitMissionToStaffReport: {
      url: '/mission-to-staffs/:id/submit-report',
      method: 'POST'
    },
    getTravelExpenses: {
      url: '/mission-to-staffs/:id/travel-expenses',
      method: 'GET'
    },
    createOrUpdateTravelExpenses: {
      url: '/mission-to-staffs/:id/travel-expenses',
      method: 'POST'
    },
    sendTravelExpensesToLEC: {
      url: '/mission-to-staffs/:id/travel-expenses/send-to-lec',
      method: 'POST'
    },
    validateTravelExpenses: {
      url: '/mission-to-staffs/:id/travel-expenses/validate',
      method: 'POST'
    },
    openTravelExpenses: {
      url: '/mission-to-staffs/:id/travel-expenses/open',
      method: 'POST'
    },
    markMissionCompleted: {
      url: '/mission-to-staffs/:id/complete',
      method: 'POST'
    },
    markMissionIncomplete: {
      url: '/mission-to-staffs/:id/incomplete',
      method: 'POST'
    },
    validateReport: {
      url: '/mission-to-staffs/:id/validate-report',
      method: 'POST'
    },
    blockMissionToStaffTravelExpenses: {
      url: '/mission-to-staffs/:id/block-travel-expenses',
      method: 'POST'
    },
    unblockMissionToStaffTravelExpenses: {
      url: '/mission-to-staffs/:id/unblock-travel-expenses',
      method: 'POST'
    },
    updateTravelExpensesCurrency: {
      url: '/mission-to-staffs/:id/travel-expenses/currency',
      method: 'POST'
    }
  },
  staffPayScales: {
    getAll: {
      url: '/staff-pay-scales',
      method: 'GET'
    },
    get: {
      url: '/staff-pay-scales/:id',
      method: 'GET',
      queryKeys: (id: number) => ['staff-pay-scale', id]
    },
    create: {
      url: '/staff-pay-scales',
      method: 'POST'
    },
    update: {
      url: '/staff-pay-scales/:id',
      method: 'PATCH'
    },
    exportExcel: {
      url: '/staff-pay-scales/export-excel',
      method: 'POST'
    }
  },
  scoreCards: {
    get: {
      url: '/score-cards/:id',
      method: 'GET'
    },
    update: {
      url: '/score-cards/:id',
      method: 'PATCH'
    }
  },
  ols: {
    getAll: {
      url: '/ols',
      method: 'GET'
    },
    get: {
      url: '/ols/:id',
      method: 'GET'
    },
    getOlOtherContacts: {
      url: '/ols/:id/other-contacts',
      method: 'GET'
    },
    create: {
      url: '/ols',
      method: 'POST'
    },
    update: {
      url: '/ols/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/ols',
      method: 'DELETE'
    },
    exportIbansExcel: {
      url: '/ols/export-ibans-excel',
      method: 'POST'
    },
    connect: {
      url: '/ols/:id/connect',
      method: 'POST'
    },
    deactivate: {
      url: '/ols/:id/deactivate',
      method: 'POST'
    },
    activate: {
      url: '/ols/:id/activate',
      method: 'POST'
    },
    getOlJourneyPlaces: {
      url: '/ols/:id/journey-places',
      method: 'GET'
    },
    sendEmail: {
      url: '/ols/send-email-to-ols',
      method: 'POST'
    },
    createOlCommission: {
      url: '/commissions',
      method: 'POST'
    },
    getAllOlCommissions: {
      url: '/commissions',
      method: 'GET'
    },
    getOlCommissionsByOl: {
      url: '/ols/:olId/commissions',
      method: 'GET'
    },
    getOlCommission: {
      url: '/commissions/:id',
      method: 'GET'
    },
    updateOlCommission: {
      url: '/commissions/:id',
      method: 'PATCH'
    },
    duplicateOlCommission: {
      url: '/commissions/:id/duplicate',
      method: 'POST'
    },
    deleteOlCommissions: {
      url: '/commissions',
      method: 'DELETE'
    },

    createOlHostFamilyPrice: {
      url: '/ols/:olId/host-family-prices',
      method: 'POST'
    },
    getOlHostFamilyPrices: {
      url: '/ols/:olId/host-family-prices',
      method: 'GET'
    },
    getOlHostFamilyPrice: {
      url: '/ols/:olId/host-family-prices/:id',
      method: 'GET'
    },
    duplicateOlHostFamilyPrice: {
      url: '/ols/:olId/host-family-prices/:id/duplicate',
      method: 'POST'
    },
    updateOlHostFamilyPrice: {
      url: '/ols/:olId/host-family-prices/:id',
      method: 'PATCH'
    },
    deleteOlHostFamilyPrices: {
      url: '/ols/:olId/host-family-prices',
      method: 'DELETE'
    },
    createOlTeflPrice: {
      url: '/ols/:olId/tefl-prices',
      method: 'POST'
    },
    getOlTeflPrices: {
      url: '/ols/:olId/tefl-prices',
      method: 'GET'
    },
    duplicateOlTeflPrice: {
      url: '/ols/:olId/tefl-prices/:id/duplicate',
      method: 'POST'
    },
    getOlTeflPrice: {
      url: '/ols/:olId/tefl-prices/:id',
      method: 'GET'
    },
    updateOlTeflPrice: {
      url: '/ols/:olId/tefl-prices/:id',
      method: 'PATCH'
    },
    deleteOlTeflPrices: {
      url: '/ols/:olId/tefl-prices',
      method: 'DELETE'
    },
    createTeachingHall: {
      url: '/ols/:olId/teaching-halls',
      method: 'POST'
    },
    getTeachingHalls: {
      url: '/ols/:olId/teaching-halls',
      method: 'GET'
    },
    getAllTeachingHalls: {
      url: '/teaching-halls',
      method: 'GET'
    },
    getTeachingHall: {
      url: '/ols/:olId/teaching-halls/:id',
      method: 'GET'
    },
    updateTeachingHall: {
      url: '/ols/:olId/teaching-halls/:id',
      method: 'PATCH'
    },
    deleteTeachingHalls: {
      url: '/ols/:olId/teaching-halls',
      method: 'DELETE'
    },
    getMobileNumberForFrenchLeaders: {
      url: '/ols/:olId/mobile-number-for-french-leaders',
      method: 'GET'
    },
    getMobileNumberForFrenchLeader: {
      url: '/ols/:olId/mobile-number-for-french-leaders/:id',
      method: 'GET'
    },
    createMobileNumberForFrenchLeader: {
      url: '/ols/:olId/mobile-number-for-french-leaders',
      method: 'POST'
    },
    updateMobileNumberForFrenchLeader: {
      url: '/ols/:olId/mobile-number-for-french-leaders/:id',
      method: 'PATCH'
    },
    deleteMobileNumberForFrenchLeaders: {
      url: '/ols/:olId/mobile-number-for-french-leaders',
      method: 'DELETE'
    },
    getActivities: {
      url: '/ols/:olId/activities',
      method: 'GET'
    },
    getActivity: {
      url: '/ols/:olId/activities/:id',
      method: 'GET'
    },
    createActivity: {
      url: '/ols/:olId/activities',
      method: 'POST'
    },
    updateActivity: {
      url: '/ols/:olId/activities/:id',
      method: 'PATCH'
    },
    deleteActivities: {
      url: '/ols/:olId/activities',
      method: 'DELETE'
    },
    getCoachCompanies: {
      url: '/ols/:olId/coach-companies',
      method: 'GET'
    },
    getAllCoachCompanies: {
      url: '/coach-companies',
      method: 'GET'
    },
    getCoachCompany: {
      url: '/ols/:olId/coach-companies/:id',
      method: 'GET'
    },
    createCoachCompany: {
      url: '/ols/:olId/coach-companies',
      method: 'POST'
    },
    updateCoachCompany: {
      url: '/ols/:olId/coach-companies/:id',
      method: 'PATCH'
    },
    deleteCoachCompanies: {
      url: '/ols/:olId/coach-companies',
      method: 'DELETE'
    },
    getTeachingHallHistoryOfAssignments: {
      url: '/ols/:olId/teaching-halls/:id/history-of-assignments',
      method: 'GET'
    }
  },
  culturalOutings: {
    getAll: {
      url: '/cultural-outings',
      method: 'GET'
    },
    get: {
      url: '/cultural-outings/:id',
      method: 'GET'
    },
    create: {
      url: '/cultural-outings',
      method: 'POST'
    },
    update: {
      url: '/cultural-outings/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/cultural-outings',
      method: 'DELETE'
    }
  },
  arrivalAndDeparture: {
    getAll: {
      url: '/arrivals-and-departures',
      method: 'GET'
    },
    get: {
      url: '/arrivals-and-departures/:id',
      method: 'GET'
    },
    create: {
      url: '/arrivals-and-departures',
      method: 'POST'
    },
    update: {
      url: '/arrivals-and-departures/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/arrivals-and-departures',
      method: 'DELETE'
    }
  },
  quotation: {
    getAll: {
      url: '/quotations',
      method: 'GET'
    },
    get: {
      url: '/quotations/:id',
      method: 'GET'
    },
    create: {
      url: '/quotations',
      method: 'POST'
    },
    update: {
      url: '/quotations/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/quotations',
      method: 'DELETE'
    }
  },
  tefl: {
    create: {
      url: '/:olId/tefls',
      method: 'POST'
    },
    get: {
      url: '/:olId/tefls/:id',
      method: 'GET'
    },
    getHistory: {
      url: '/:olId/tefls/:teflId/history',
      method: 'GET'
    },
    getHistoryInfo: {
      url: '/:olId/tefls/:teflId/history/info',
      method: 'GET'
    },
    getAllTeflByOlId: {
      url: '/:olId/tefls',
      method: 'GET'
    },
    getAll: {
      url: '/tefls',
      method: 'GET'
    },
    update: {
      url: '/:olId/tefls/:id',
      method: 'PATCH'
    },
    createComment: {
      url: '/:olId/tefls/comment',
      method: 'POST'
    },
    deleteComment: {
      url: '/:olId/tefls/comment/:commentId',
      method: 'DELETE'
    },
    updateComment: {
      url: '/:olId/tefls/comment/:commentId',
      method: 'PATCH'
    },
    delete: {
      url: '/:olId/tefls',
      method: 'DELETE'
    },
    createTeflLecComment: {
      url: '/tefls/:teflId/lec-comments',
      method: 'POST'
    },
    getTeflLecComments: {
      url: '/tefls/:teflId/lec-comments',
      method: 'GET'
    },
    updateTeflLecComment: {
      url: '/tefls/:teflId/lec-comments/:id',
      method: 'PATCH'
    },
    deleteTeflLecComments: {
      url: '/tefls/:teflId/lec-comments',
      method: 'DELETE'
    },
    createTeflOlComment: {
      url: '/tefls/:teflId/ol-comments',
      method: 'POST'
    },
    getTeflOlComments: {
      url: '/tefls/:teflId/ol-comments',
      method: 'GET'
    },
    updateTeflOlComment: {
      url: '/tefls/:teflId/ol-comments/:id',
      method: 'PATCH'
    },
    deleteTeflOlComments: {
      url: '/tefls/:teflId/ol-comments',
      method: 'DELETE'
    }
  },

  'trip-bookings': {
    getAll: {
      url: '/trip-bookings',
      method: 'GET'
    },
    create: {
      url: '/trip-bookings',
      method: 'POST'
    },
    update: {
      url: '/trip-bookings/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/trip-bookings/:id',
      method: 'DELETE'
    },
    get: {
      url: '/trip-bookings/:id',
      method: 'GET'
    },
    duplicate: {
      url: '/trip-bookings/:id/duplicate',
      method: 'POST'
    },
    lock: {
      url: '/trip-bookings/:id/lock',
      method: 'POST'
    },
    unlock: {
      url: '/trip-bookings/:id/unlock',
      method: 'POST'
    },
    exportExcel: {
      url: '/trip-bookings/export-excel',
      method: 'POST'
    },
    exportPassengersExcel: {
      url: '/trip-bookings/export-passengers-excel',
      method: 'POST'
    },
    createReminder: {
      url: '/trip-bookings/:id/reminders',
      method: 'POST'
    },
    updateReminder: {
      url: '/trip-bookings/:id/reminders/:reminderId',
      method: 'PATCH'
    },
    getReminders: {
      url: '/trip-bookings/:id/reminders',
      method: 'GET'
    },
    createDocument: {
      url: '/trip-bookings/:id/documents',
      method: 'POST'
    },
    getDocuments: {
      url: '/trip-bookings/:id/documents',
      method: 'GET'
    },
    updateDocument: {
      url: '/trip-bookings/:id/documents/:documentId',
      method: 'PATCH'
    },
    createPayment: {
      url: '/trip-bookings/:id/payments',
      method: 'POST'
    },
    getTripBookingTripPlaceToCenterRequests: {
      url: '/trip-bookings/:id/trip-place-to-center-requests',
      method: 'GET'
    },
    updateTripBookingAllocations: {
      url: '/trip-bookings/:id/allocations',
      method: 'PATCH'
    },
    getPayments: {
      url: '/trip-bookings/:id/payments',
      method: 'GET'
    },
    updatePayment: {
      url: '/trip-bookings/:id/payments/:paymentId',
      method: 'PATCH'
    },
    createTripStep: {
      url: '/trip-bookings/:id/trip-steps',
      method: 'POST'
    },
    getTripSteps: {
      url: '/trip-bookings/:id/trip-steps',
      method: 'GET'
    },
    updateTripStep: {
      url: '/trip-bookings/:id/trip-steps/:tripStepId',
      method: 'PATCH'
    },
    deleteTripStep: {
      url: '/trip-bookings/:id/trip-steps/:tripStepId',
      method: 'DELETE'
    },
    sendUpdateNotification: {
      url: '/trip-bookings/:id/send-update-notification',
      method: 'POST'
    },
    sendLockedUpdateNotification: {
      url: '/trip-bookings/:id/send-locked-update-notification',
      method: 'POST'
    }
  },
  blockedPlaces: {
    getAll: {
      url: '/centers/:id/blocked-places',
      method: 'GET'
    },
    getTripOptions: {
      url: '/centers/:id/blocked-places/trip-options',
      method: 'GET'
    },
    create: {
      url: '/centers/:id/blocked-places',
      method: 'POST'
    },
    update: {
      url: '/centers/:centerId/blocked-places/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/centers/:centerId/blocked-places/:id',
      method: 'DELETE'
    },
    deleteMany: {
      url: '/centers/:centerId/blocked-places',
      method: 'DELETE'
    },
    affect: {
      url: '/centers/:centerId/blocked-places/:id/affect',
      method: 'POST'
    },
    unAffect: {
      url: '/centers/:centerId/blocked-places/:id/un-affect',
      method: 'POST'
    }
  },
  tripProviders: {
    getAll: {
      url: '/trip-providers',
      method: 'GET'
    },
    create: {
      url: '/trip-providers',
      method: 'POST'
    },
    update: {
      url: '/trip-providers/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/trip-providers/:id',
      method: 'DELETE'
    },
    get: {
      url: '/trip-providers/:id',
      method: 'GET'
    },
    createContact: {
      url: '/trip-providers/:id/contacts',
      method: 'POST'
    },
    updateContact: {
      url: '/trip-providers/:id/contacts/:contactId',
      method: 'PATCH'
    },
    deleteContact: {
      url: '/trip-providers/:id/contacts/:contactId',
      method: 'DELETE'
    },
    getContacts: {
      url: '/trip-providers/:id/contacts',
      method: 'GET'
    }
  },
  canGoOutAloneCondition: {
    getAll: {
      url: '/can-go-out-alone-conditions',
      method: 'GET'
    },
    get: {
      url: '/can-go-out-alone-conditions/:id',
      method: 'GET'
    },
    create: {
      url: '/can-go-out-alone-conditions',
      method: 'POST'
    },
    update: {
      url: '/can-go-out-alone-conditions/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/can-go-out-alone-conditions/:id',
      method: 'DELETE'
    },
    getCanGoOutAloneOption: {
      url: '/can-go-out-alone-conditions/option',
      method: 'GET'
    }
  },
  teachingHallComments: {
    create: {
      url: '/teaching-halls/:teachingHallId/comments',
      method: 'POST'
    },
    getAll: {
      url: '/teaching-halls/:teachingHallId/comments',
      method: 'GET'
    },
    get: {
      url: '/teaching-halls/:teachingHallId/comments/:commentId',
      method: 'GET'
    },
    update: {
      url: '/teaching-halls/:teachingHallId/comments/:commentId',
      method: 'PATCH'
    },
    delete: {
      url: '/teaching-halls/:teachingHallId/comments',
      method: 'DELETE'
    }
  },
  languageTest: {
    getTemplates: {
      url: '/language-tests/templates',
      method: 'GET'
    },
    getTemplate: {
      url: '/language-tests/templates/:id',
      method: 'GET'
    },
    createTemplate: {
      url: '/language-tests/templates',
      method: 'POST'
    },
    updateTemplate: {
      url: '/language-tests/templates/:id',
      method: 'PATCH'
    },
    deleteTemplate: {
      url: '/language-tests/templates/:id',
      method: 'DELETE'
    },
    getSection: {
      url: '/language-tests/sections/:id',
      method: 'GET'
    },
    createSection: {
      url: '/language-tests/sections/:templateId',
      method: 'POST'
    },
    updateSection: {
      url: '/language-tests/sections/:id',
      method: 'PATCH'
    },
    deleteSection: {
      url: '/language-tests/sections/:id',
      method: 'DELETE'
    },
    updateSectionPositions: {
      url: '/language-tests/sections/:templateId/positions',
      method: 'PUT'
    },
    createQuestion: {
      url: '/language-tests/questions/:sectionId',
      method: 'POST'
    },
    updateQuestion: {
      url: '/language-tests/questions/:sectionId/:id',
      method: 'PATCH'
    },
    deleteQuestion: {
      url: '/language-tests/questions/:id',
      method: 'DELETE'
    },
    // Submission endpoints
    getActiveSubmission: {
      url: '/enrollments/:id/submissions/active',
      method: 'GET'
    },
    createSubmission: {
      url: '/enrollments/:id/submissions',
      method: 'POST'
    },
    getActions: {
      url: '/enrollments/:id/language-tests/actions',
      method: 'GET'
    },
    goToNextSection: {
      url: '/language-tests/submissions/:submissionId/next',
      method: 'POST'
    },
    goToPreviousSection: {
      url: '/language-tests/submissions/:submissionId/previous',
      method: 'POST'
    },
    saveResponse: {
      url: '/language-tests/submissions/:submissionId',
      method: 'POST'
    },
    finalizeSubmission: {
      url: '/language-tests/submissions/:submissionId/finalize',
      method: 'POST'
    },
    getMissingQuestions: {
      url: '/language-tests/submissions/:submissionId/missing-questions',
      method: 'GET'
    },
    getRemainingTime: {
      url: '/language-tests/submissions/:submissionId/remaining-time',
      method: 'GET'
    }
  },
  budgetAllocation: {
    getAll: {
      url: '/budget-allocations',
      method: 'GET'
    },
    create: {
      url: '/budget-allocations',
      method: 'POST'
    },
    getTotalAllocatedBudgets: {
      url: '/budget-allocations/total-allocated-budgets',
      method: 'GET'
    },
    generateBudgetAllocationReceipt: {
      url: '/budget-allocations/:id/generate-receipt',
      method: 'POST'
    },
    generateBudgetAllocationReceipts: {
      url: '/budget-allocations/generate-receipts',
      method: 'GET'
    },
    exportExcel: {
      url: '/budget-allocations/export-excel',
      method: 'POST'
    },
    delete: {
      url: '/budget-allocations/:id',
      method: 'DELETE'
    }
  },

  tripsSchedule: {
    getAll: {
      url: '/trips-schedule',
      method: 'GET'
    },
    check: {
      url: '/trips-schedule/:code/check',
      method: 'POST'
    },
    uncheck: {
      url: '/trips-schedule/:code/uncheck',
      method: 'POST'
    },
    getTripScheduleIndividuals: {
      url: '/trips-schedule/individuals',
      method: 'GET'
    }
  },
  'enrollment-accountings': {
    getAll: {
      url: '/enrollment-accountings',
      method: 'GET'
    },
    getRemindersHistory: {
      url: '/enrollment-accountings/:id/reminders-history',
      method: 'GET'
    },
    getEnrollmentAccountingPaymentsInfo: {
      url: '/enrollment-accountings/payments-info',
      method: 'GET'
    },
    sendEmailReminder: {
      url: '/enrollment-accountings/reminder-by-email',
      method: 'POST'
    },
    sendPhoneReminder: {
      url: '/enrollment-accountings/reminder-by-phone',
      method: 'POST'
    },
    addComment: {
      url: '/enrollment-accountings/:id/comment',
      method: 'POST'
    }
  },
  'end-of-journey-templates': {
    getAll: {
      url: '/end-of-journey-templates',
      method: 'GET'
    },
    create: {
      url: '/end-of-journey-templates',
      method: 'POST'
    },
    get: {
      url: '/end-of-journey-templates/:id',
      method: 'GET'
    },
    update: {
      url: '/end-of-journey-templates/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/end-of-journey-templates',
      method: 'DELETE'
    },
    getColumnCodes: {
      url: '/end-of-journey-templates/column-codes',
      method: 'GET'
    },
    getQuestions: {
      url: '/end-of-journey-templates/:id/questions',
      method: 'GET'
    },
    createQuestion: {
      url: '/end-of-journey-templates/:id/questions',
      method: 'POST'
    },
    updateQuestion: {
      url: '/end-of-journey-templates/:id/questions/:questionId',
      method: 'PATCH'
    },
    reorderQuestions: {
      url: '/end-of-journey-templates/:id/questions/reorder',
      method: 'PUT'
    },
    deleteQuestions: {
      url: '/end-of-journey-templates/:id/questions',
      method: 'DELETE'
    },
    generateTemplatePdf: {
      url: '/end-of-journey-templates/:id/generate-questions-pdf',
      method: 'POST'
    }
  },
  'end-of-journey-questionnaires': {
    get: {
      url: '/enrollments/:id/end-of-journey-questionnaire',
      method: 'GET'
    },
    upsert: {
      url: '/enrollments/:id/end-of-journey-questionnaire',
      method: 'PUT'
    }
  },
  'end-of-journey-reviews-summary': {
    get: {
      url: '/end-of-journey-reviews/summary',
      method: 'GET'
    },
    exportExcel: {
      url: '/end-of-journey-reviews/summary/export-excel',
      method: 'GET'
    }
  },
  'end-of-journey-scans': {
    create: {
      url: '/end-of-journey-scans',
      method: 'POST'
    },
    getAll: {
      url: '/end-of-journey-scans',
      method: 'GET'
    },
    getUploadLimits: {
      url: '/end-of-journey-scans/upload-limits',
      method: 'GET'
    },
    reuploadItem: {
      url: '/end-of-journey-scans/:id/reupload',
      method: 'POST'
    },
    retryItem: {
      url: '/end-of-journey-scans/:id/retry',
      method: 'POST'
    },
    getItemManualForm: {
      url: '/end-of-journey-scans/:id/manual-form',
      method: 'GET'
    },
    getItemEnrollmentCandidates: {
      url: '/end-of-journey-scans/:id/enrollment-candidates',
      method: 'GET'
    },
    resolveItem: {
      url: '/end-of-journey-scans/:id/manual',
      method: 'PUT'
    }
  },
  lecBankAccounts: {
    getAll: {
      url: '/lec-bank-accounts',
      method: 'GET'
    },
    get: {
      url: '/lec-bank-accounts/:id',
      method: 'GET'
    },
    create: {
      url: '/lec-bank-accounts',
      method: 'POST'
    },
    update: {
      url: '/lec-bank-accounts/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/lec-bank-accounts/:id',
      method: 'DELETE'
    }
  },
  centerOlPayments: {
    getAll: {
      url: '/center-ol-payments',
      method: 'GET'
    },
    get: {
      url: '/center-ol-payments/:id',
      method: 'GET'
    },
    getSuggestions: {
      url: '/center-ol-payments/suggestions',
      method: 'GET'
    },
    getSuggestedAdvanceAmount: {
      url: '/center-ol-payments/suggested-advance-amount',
      method: 'GET'
    },
    create: {
      url: '/center-ol-payments',
      method: 'POST'
    },
    generateAdvancePayment: {
      url: '/center-ol-payments/generate-advance-payment',
      method: 'POST'
    },
    generateCostPayment: {
      url: '/center-ol-payments/generate-cost-payment',
      method: 'POST'
    },
    generateFinalCostPayment: {
      url: '/center-ol-payments/generate-final-cost-payment',
      method: 'POST'
    },
    generateXml: {
      url: '/center-ol-payments/generate-xml',
      method: 'GET'
    },
    generateBankTransferOrder: {
      url: '/center-ol-payments/:id/bank-transfer-order',
      method: 'GET'
    },
    getTotalAmountsByCurrency: {
      url: '/center-ol-payments/total-amounts-by-currency',
      method: 'GET'
    },
    validate: {
      url: '/center-ol-payments/validate',
      method: 'POST'
    },
    downloadInvoices: {
      url: '/center-ol-payments/download-invoices',
      method: 'GET'
    },
    update: {
      url: '/center-ol-payments/:id',
      method: 'PATCH'
    },
    delete: {
      url: '/center-ol-payments',
      method: 'DELETE'
    }
  },
  queues: {
    getLatestBatch: {
      url: '/queues/users/:id/latest-batch',
      method: 'GET'
    },
    getBatches: {
      url: '/queues/users/:id/batches',
      method: 'GET'
    },
    clearLatestBatch: {
      url: '/queues/users/:id/clear-batch/:batchId',
      method: 'DELETE'
    }
  }
} as const

type ExtractUrls<T> = T extends { url: infer U }
  ? U
  : {
      [K in keyof T]: ExtractUrls<T[K]>
    }[keyof T]

type ExtractQueryKeys<T> = T extends { queryKeys: infer U }
  ? U
  : T extends object
    ? {
        [K in keyof T]: ExtractQueryKeys<T[K]>
      }[keyof T]
    : never

export type QueryKeys =
  ExtractQueryKeys<typeof API> extends readonly string[] ? ExtractQueryKeys<typeof API> : []

export type ApiUrls = ExtractUrls<typeof API>

type ExtractParam<S extends string> = S extends `${infer _Start}:${infer Param}/${infer Rest}`
  ? [Param, ...ExtractParam<`/${Rest}`>]
  : S extends `${infer _Start}:${infer Param}`
    ? [Param]
    : []

export type ApiUrlParam<T extends ApiUrls> = ExtractParam<T>

type ParamsToObject<T extends readonly string[]> = {
  [K in T[number]]: string | number
}
type ConstructApiUrlParams<T extends ApiUrls> =
  ApiUrlParam<T> extends [] ? null : ParamsToObject<ApiUrlParam<T>>

export const constructApiUrl = <T extends ApiUrls>(
  url: T,
  params: ConstructApiUrlParams<T>
): string => {
  if (!params) return url
  return url.replace(/:([a-zA-Z]+)/g, (_, key) => {
    return params[key as keyof typeof params].toString()
  })
}
